// import React, { useState, useEffect } from 'react';
// import {
//     Typography,
//     Table,
//     TableBody,
//     TableCell,
//     TableContainer,
//     TableHead,
//     TableRow,
//     Paper,
//     Stack,
//     Button,
//     TextField,
//     Grid,
//     Modal,
//     Box,
//     Divider,
//     Badge,
//     IconButton,
//     Popover,
//     FormControlLabel,
//     CircularProgress
// } from '@mui/material';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { Icon } from '@iconify/react';
// import Iconify from '../components/iconify';
// import { Api } from '../webservices';
// // import Scrollbar from 'src/components/scrollbar/Scrollbar';
// import Scrollbar from '../components/scrollbar/Scrollbar';

// const MasterData = () => {
//     const [isEditing, setIsEditing] = useState(false);
//     const [editedTitle, setEditedTitle] = useState('');
//     const [addJobTitle, setAddJobTitle] = useState('');
//     const [addSkillTitle, setAddSkillTitle] = useState('');
//     const [addCompanyTitle, setAddCompanyTitle] = useState('');
//     const [data, setData] = useState([]);
//     const [splitData, setSplitData] = useState({ part1: [], part2: [] });
//     const [titleId, setTitleId] = useState(null);
//     const [selectedType, setSelectedType] = useState('job');
//     const [del, setDel] = useState(false);
//     const [deleteId, setDeleteId] = useState(null);
//     const [softDelete, setSoftDelete] = useState('')
//     const [loading, setLoading] = useState(false)
//     const [inputData, setInputData] = useState('')
//     const openDeleteModal = (actionType) => {
//         // setDeleteId(id);
//         setSoftDelete(actionType)
//         setDel(true);
//     };

//     const closeDeleteModal = () => {
//         setDeleteId(null);
//         setDel(false);
//     };

//     const style = {
//         position: 'absolute',
//         top: '50%',
//         left: '50%',
//         transform: 'translate(-50%, -50%)',
//         width: { md: '50%', xs: '95%' },
//         bgcolor: 'background.paper',
//         boxShadow: 24,
//         p: 3,
//         border: '3px solid #3C6BA5',
//         borderRadius: 3,
//     };

//     useEffect(() => {
//         if (selectedType === 'job') {
//             getJobTitles();
//         } else if (selectedType === 'skill') {
//             getSkillTitles();
//         } else if (selectedType === 'company') {
//             getCompanyTitles();
//         }
//         else if (selectedType === 'deletedskills') {
//             getSoftDeletedSkillsLst();
//         }
//         else if (selectedType === 'deletedjobtitles') {
//             getJobTitlesLst()
//         }
//         else if (selectedType === 'deletedcompanies') {
//             getSoftDeletedCompsLst()
//         }
//     }, [selectedType]);

//     useEffect(() => {
//         const half = Math.ceil(data?.length / 2);
//         setSplitData({ part1: data?.slice(0, half), part2: data?.slice(half) });
//     }, [data]);

//     const handleEditClick = (id, currentTitle) => {
//         setIsEditing(true);
//         setTitleId(id);
//         setEditedTitle(currentTitle);
//     };

//     const handleSaveClick = () => {
//         setIsEditing(false);
//         if (selectedType === 'job') {
//             updateJobTitle(titleId);
//         } else if (selectedType === 'skill') {
//             updateSkillTitle(titleId);
//         } else if (selectedType === 'company') {
//             updateCompanyTitle(titleId);
//         }
//     };

//     const getJobTitles = () => {
//         setLoading('Loading...')
//         setData([]);
//         const token = localStorage.getItem('token');
//         Api(`common/jobtitle/get/active`, 'GET', '', token)
//             .then((response) => {
//                 if (response.status === 200 && response.data.code === 200) {
//                     setData(response.data.jobTitles);
//                     setLoading('')
//                 } else {
//                     setLoading('No data found')
//                 }
//             })
//             .catch((err) => {
//                 console.error(err);
//             });
//     };

//     const getJobTitlesLst = () => {
//         setLoading('Loading...');
//         setData([]);

//         const token = localStorage.getItem('token');

//         Api('common/jobtitle/get/inactive', 'GET', '', token)
//             .then((response) => {

//                 if (response.status === 200 && response.data.code === 200) {
//                     const jobTitles = response.data.jobTitles;

//                     if (jobTitles.length === 0) {
//                         setLoading('No data found');
//                     } else {
//                         setData(jobTitles);
//                         setLoading('');
//                     }
//                 } else {
//                     setLoading('No data found');
//                 }
//             })
//             .catch((err) => {
//                 console.error(err);
//                 // setLoading('An error occurred');
//             });
//     };


//     const getSkillTitles = () => {
//         setData([]);
//         setLoading('Loading...')
//         const token = localStorage.getItem('token');
//         Api(`resume/get_skills/${"masterdata"}`, 'GET', '', token)
//             .then((response) => {
//                 if (response.status === 200 && response.data.code === 200) {
//                     setData(response.data.result);
//                     setLoading('')
//                 } else {
//                     setLoading('No data found')
//                 }
//             })
//             .catch((err) => {
//                 console.error(err);
//             });
//     };

//     const getSoftDeletedSkillsLst = () => {
//         setLoading('Loading...');
//         setData([]);

//         const token = localStorage.getItem('token');

//         Api('resume/softDeleteSkillList', 'GET', '', token)
//             .then((response) => {

//                 if (response.status === 200 && response.data.code === 200) {
//                     const result = response.data.result;

//                     if (result.length === 0) {
//                         setLoading('No data found');
//                     } else {
//                         setData(result);
//                         setLoading('');
//                     }
//                 } else {
//                     setLoading('No data found');
//                 }
//             })
//             .catch((err) => {
//                 console.error(err);
//                 // setLoading('An error occurred');
//             });
//     };

//     const getCompanyTitles = () => {
//         setData([]);
//         setLoading('Loading...')
//         const token = localStorage.getItem('token');
//         Api(`common/companyName/get/active`, 'GET', '', token)
//             .then((response) => {
//                 if (response.status === 200 && response.data.code === 200) {
//                     setData(response.data.companies);
//                     setLoading('')
//                 } else {
//                     setLoading('No data found')

//                 }
//             })
//             .catch((err) => {
//                 console.error(err);
//             });
//     };

//     const getSoftDeletedCompsLst = () => {
//         setLoading('Loading...');
//         setData([]);

//         const token = localStorage.getItem('token');
//         Api(`common/companyName/get/inactive`, 'GET', '', token)
//             .then((response) => {
//                 if (response.status === 200 && response.data.code === 200) {
//                     const companies = response.data.companies;

//                     if (companies.length === 0) {
//                         setLoading('No data found');
//                     } else {
//                         setData(companies);
//                         setLoading('');
//                     }
//                 } else {
//                     setLoading('No data found');
//                     // alert('Error fetching data');
//                 }
//             })
//             .catch((err) => {
//                 console.error(err);
//                 // setLoading('An error occurred');
//             });
//     };


//     const addJobTitleFunc = () => {
//         const addJobTitles = addJobTitle.split(',').map(title => title.trim());
//         addJobTitles.forEach(title => {
//             const body = {
//                 jobTitle: title,
//                 jobTitleStatus: "approved"

//             };
//             const token = localStorage.getItem('token');
//             Api(`common/jobtitle/add`, 'POST', body, token)
//                 .then((response) => {
//                     if (response.status === 200 && response.data.code === 200) {
//                         getJobTitles();
//                         setAddJobTitle('');
//                         toast.success(`Job title added successfully!`);
//                     } else {
//                         toast.error(`Job title already exists!`);
//                         setAddJobTitle('');
//                     }
//                 })
//                 .catch((err) => {
//                     console.error(err);
//                     // toast.error(`Failed to add job title "${title}"`);
//                 });
//         });
//     };

//     const moveToJobTitle = (id) => {
//         const body = {
//             jobtitle_id: id._id,

//         };
//         const token = localStorage.getItem('token');
//         Api(`common/moveToJobtitle`, 'POST', body, token)
//             .then((response) => {
//                 if (response.status === 200 && response.data.code === 200) {
//                     getJobTitles();
//                     toast.success("job title_id moved successfully!");
//                 } else {
//                     toast.error("job title_id already exists!")
//                 }
//             })
//             // toast.error("Skill already exists")
//             .catch((err) => {
//                 console.error(err);
//             });
//     };

//     const moveToSkill = (item) => {
//         const body = {
//             skillName: item.skillName,
//             skillStatus: "approved",
//         };
//         const token = localStorage.getItem('token');
//         Api(`common/skill/update/${item._id}`, 'PUT', body, token)
//             .then((response) => {
//                 if (response.status === 200 && response.data.code === 200) {
//                     getSkillTitles();
//                     toast.success("Skill moved successfully!");
//                 } else {
//                     toast.error("Skill already exists!")
//                 }
//             })
//             // toast.error("Skill already exists")
//             .catch((err) => {
//                 console.error(err);
//             });
//     };

//     const moveToCompany = (item) => {
//         const body = {
//             companyName: item.companyName,
//             companyNameStatus: "approved",
//         };
//         const token = localStorage.getItem('token');
//         Api(`common/companyName/update/${item._id}`, 'PUT', body, token)
//             .then((response) => {
//                 if (response.status === 200 && response.data.code === 200) {
//                     getCompanyTitles();
//                     toast.success("Company moved successfully!");
//                 } else {
//                     toast.error("Company already exists!")
//                 }
//             })
//             .catch((err) => {
//                 console.error(err);
//             });
//     };

//     const addSkillTitleFunc = () => {
//         const skillTitles = addSkillTitle?.split(',')?.map(skill => skill?.trim()?.toLowerCase());
//         const token = localStorage.getItem('token');

//         Promise.all(skillTitles?.map(skill => {
//             const body = {
//                 skillName: skill,
//                 skillStatus: "approved",
//             };
//             return Api(`common/skill/add`, 'POST', body, token);
//         }))
//             .then(responses => {
//                 if (responses.every(response => response.status === 200 && response.data.code === 200)) {
//                     getSkillTitles();
//                     setAddSkillTitle('');
//                     toast.success("Skill ddded successfully!");
//                 } else {
//                     toast.error("Skill already exist!");
//                     getSkillTitles();
//                     setAddSkillTitle('');
//                 }
//             })
//             .catch((err) => {
//                 console.error(err);
//             });
//     };

//     const addCompanyTitleFunc = () => {
//         const addCompanyTitles = addCompanyTitle.split(',').map(title => title.trim());
//         addCompanyTitles.forEach(title => {
//             const body = {
//                 companyName: title,
//                 companyNameStatus: "approved"
//             };
//             const token = localStorage.getItem('token');
//             Api(`common/companyName/add`, 'POST', body, token)
//                 .then((response) => {
//                     if (response.status === 200 && response.data.code === 200) {
//                         getCompanyTitles();
//                         setAddCompanyTitle('');
//                         toast.success(`Company title added successfully!`);
//                     } else {
//                         toast.error(`Company already exists!`);
//                         setAddCompanyTitle('');
//                     }
//                 })
//                 .catch((err) => {
//                     console.error(err);
//                     // toast.error(`Failed to add company title`);
//                 });
//         });
//     };

//     const updateJobTitle = (id) => {
//         const body = {
//             jobTitle: editedTitle?.trim(),
//         };
//         const token = localStorage.getItem('token');
//         Api(`common/jobtitle/update/${id}`, 'PUT', body, token)
//             .then((response) => {
//                 if (response.status === 200 && response.data.code === 200) {
//                     getJobTitles();
//                     toast.success("Job title updated successfully!");
//                 }
//             })
//             .catch((err) => {
//                 console.error(err);
//             });
//     };

//     const updateSkillTitle = (id) => {
//         const body = {
//             skillName: editedTitle?.trim()?.toLowerCase(),
//             skillStatus: "approved",
//         };
//         const token = localStorage.getItem('token');
//         Api(`common/skill/update/${id}`, 'PUT', body, token)
//             .then((response) => {
//                 if (response.status === 200 && response.data.code === 200) {
//                     getSkillTitles();
//                     toast.success("Skill title updated successfully!");
//                 }
//             })
//             .catch((err) => {
//                 console.error(err);
//             });
//     };

//     const updateCompanyTitle = (id) => {
//         const body = {
//             companyName: editedTitle?.trim(),
//             companyNameStatus: "approved"
//         };
//         const token = localStorage.getItem('token');
//         Api(`common/companyName/update/${id}`, 'PUT', body, token)
//             .then((response) => {
//                 if (response.status === 200 && response.data.code === 200) {
//                     getCompanyTitles();
//                     toast.success("Company title updated successfully!");
//                 }
//             })
//             .catch((err) => {
//                 console.error(err);
//             });
//     };

//     const deleteJobTitle = (id) => {
//         const body = {
//             jobTitle: ""
//         }
//         const token = localStorage.getItem('token');
//         Api(`common/jobtitle/delete/${id}`, 'POST', body, token)
//             .then((response) => {
//                 if (response.status === 200 && response.data.code === 200) {
//                     getJobTitles();
//                     toast.success("Job title deleted successfully!");
//                 }
//             })
//             .catch((err) => {
//                 console.error(err);
//             });
//     };

//     const softdeleteJobTitle = (item) => {
//         const body = {
//             jobtitle_id: item._id,
//             status: "inactive"
//         }
//         const token = localStorage.getItem('token');
//         Api(`common/softDeleteJobtitle`, 'POST', body, token)
//             .then((response) => {
//                 if (response.status === 200 && response.data.code === 200) {
//                     // getJobTitles();
//                     setSelectedType("deletedjobtitles")
//                     toast.success("Job title deleted successfully!");
//                 }
//             })
//             .catch((err) => {
//                 console.error(err);
//             });
//     };

//     const softdeleteJobTitleMoveTo = (id) => {
//         const body = {
//             jobtitle_id: id,
//             status: "active"
//         }
//         const token = localStorage.getItem('token');
//         Api(`common/softDeleteJobtitle`, 'POST', body, token)
//             .then((response) => {
//                 if (response.status === 200 && response.data.code === 200) {
//                     // getJobTitles();
//                     toast.success("Job Title moved successfully!");
//                     getJobTitles()
//                     setSelectedType("job")
//                 }
//             })
//             .catch((err) => {
//                 console.error(err);
//             });
//     };

//     const softdeleteSkillTitle = (item) => {
//         const body = {
//             skill_id: item._id,
//             status: "inactive"
//         }
//         const token = localStorage.getItem('token');
//         Api(`resume/softDeleteSkill`, 'POST', body, token)
//             .then((response) => {
//                 if (response.status === 200 && response.data.code === 200) {
//                     // getSkillTitles();
//                     toast.success("Skill title deleted successfully!");
//                     setSelectedType("deletedskills")
//                 }
//             })
//             .catch((err) => {
//                 console.error(err);
//             });
//     };

//     const softdeleteSkillMove = (id) => {
//         const body = {
//             skill_id: id,
//             status: "active"
//         }
//         const token = localStorage.getItem('token');
//         Api(`resume/softDeleteSkill`, 'POST', body, token)
//             .then((response) => {
//                 if (response.status === 200 && response.data.code === 200) {
//                     // getSkillTitles();
//                     toast.success("Skill moved successfully!");
//                     getSkillTitles()
//                     setSelectedType("skill")
//                 }
//             })
//             .catch((err) => {
//                 console.error(err);
//             });
//     };

//     const deleteSkillTitle = (id) => {
//         const body = {
//             skillName: ""
//         }
//         const token = localStorage.getItem('token');
//         Api(`common/skill/delete/${id}`, 'POST', body, token)
//             .then((response) => {
//                 if (response.status === 200 && response.data.code === 200) {
//                     getSkillTitles();
//                     toast.success("Skill title deleted successfully!");
//                 }
//             })
//             .catch((err) => {
//                 console.error(err);
//             });
//     };

//     const softdeleteCompanyTitle = (item) => {
//         const body = {
//             company_id: item._id,
//             status: "inactive"
//         }
//         const token = localStorage.getItem('token');
//         Api(`common/softDeleteCompany`, 'POST', body, token)
//             .then((response) => {
//                 if (response.status === 200 && response.data.code === 200) {
//                     // getCompanyTitles();
//                     toast.success("Company title deleted successfully!");
//                     setSelectedType("deletedcompanies")
//                 }
//             })
//             .catch((err) => {
//                 console.error(err);
//             });
//     };

//     const softdeleteCompMove = (id) => {
//         const body = {
//             company_id: id,
//             status: "active"
//         }
//         const token = localStorage.getItem('token');
//         Api(`common/softDeleteCompany`, 'POST', body, token)
//             .then((response) => {
//                 if (response.status === 200 && response.data.code === 200) {
//                     // getSkillTitles();
//                     toast.success("Company moved successfully!");
//                     getCompanyTitles()
//                     setSelectedType("company")
//                 }
//             })
//             .catch((err) => {
//                 console.error(err);
//             });
//     };

//     const deleteCompanyTitle = (id) => {
//         const body = {
//             companyName: ""
//         }
//         const token = localStorage.getItem('token');
//         Api(`common/companyName/delete/${id}`, 'POST', body, token)
//             .then((response) => {
//                 if (response.status === 200 && response.data.code === 200) {
//                     getCompanyTitles();
//                     toast.success("Company title deleted successfully!");
//                 }
//             })
//             .catch((err) => {
//                 console.error(err);
//             });
//     };

//     const addTitleFunc = () => {
//         if (selectedType === 'job') {
//             addJobTitleFunc();
//         } else if (selectedType === 'skill') {
//             addSkillTitleFunc();
//         } else if (selectedType === 'company') {
//             addCompanyTitleFunc();
//         } else if (selectedType === 'deletedskills') {
//             toast.warn("Can't add deleted skills direclty")
//         } else if (selectedType === 'deletedjobtitles') {
//             toast.warn("Can't add deleted job titles direclty")
//         } else if (selectedType === 'deletedcompanies') {
//             toast.warn("Can't add deleted companies direclty")
//         }
//     };    

//     const addTitle = () => {
//         if (selectedType === 'job') {
//             return addJobTitle;
//         } if (selectedType === 'skill') {
//             return addSkillTitle;
//         } if (selectedType === 'company') {
//             return addCompanyTitle;
//         } if (selectedType === 'deletedcompanies') {
//             return addCompanyTitle;
//         } if (selectedType === 'deletedskills') {
//             return addSkillTitle;
//         } if (selectedType === 'deletedjobtitles') {
//             return addJobTitle;
//         }
    
//         return null;
//     };    

//     const setAddTitle = (value) => {
//         if (selectedType === 'job') {
//             setAddJobTitle(value);
//         } else if (selectedType === 'skill') {
//             setAddSkillTitle(value);
//         } else if (selectedType === 'company') {
//             setAddCompanyTitle(value);
//         } else if (selectedType === 'deletedcompanies') {
//             setAddCompanyTitle(value);
//         } else if (selectedType === 'deletedskills') {
//             setAddSkillTitle(value);
//         } else if (selectedType === 'deletedjobtitles') {
//             setAddJobTitle(value);
//         }
//     };     

//     const deleteTitleFunc = () => {
//         if (selectedType === 'job') {
//             deleteJobTitle(deleteId);
//         } else if (selectedType === 'skill') {
//             deleteSkillTitle(deleteId);
//         } else if (selectedType === 'company') {
//             deleteCompanyTitle(deleteId);
//         }
//     };

//     const deleteTitleFunc1 = () => {
//         if (softDelete === 'softdeletetitle') {
//             softdeleteJobTitle()
//             // alert("title")
//         } else if (softDelete === 'softdeleteskill') {
//             softdeleteSkillTitle()
//             // alert("skill")
//         } else if (softDelete === 'softdeletecompany') {
//             softdeleteCompanyTitle()
//             // alert("company")
//         }
//     };

//     const [modalOpen, setModalOpen] = useState(false);
//     const [modalData, setModalData] = useState(null);
//     const [altJobId, setAltJobId] = useState()
//     const [altArr, setAltArr] = useState()
//     const handleOpenModal = (altArr, id) => {
//         setAltArr(altArr)
//         // console.log("altArr", altArr)
//         setModalOpen(true);
//         setAltJobId(id)

//     };

//     const handleCloseModal = () => {
//         setModalOpen(false);
//         // setModalData(null);  
//     };

//     const initialCities = [
//         "New York", "Los Angeles", "Chicago", "Houston", "Phoenix",
//         "Philadelphia", "San Antonio", "San Diego", "Dallas", "San Jose",
//         "Austin", "Jacksonville", "Fort Worth", "Columbus", "Indianapolis",
//         "Charlotte", "Seattle", "Denver", "Washington, D.C.", "Boston",
//         // "El Paso", "Nashville", "Detroit", "Oklahoma City", "Portland",
//         // "Las Vegas", "Memphis", "Louisville", "Baltimore", "Milwaukee",
//         // "Albuquerque"
//     ];

//     const [cities, setCities] = useState(initialCities);
//     const [editIndex, setEditIndex] = useState(null);
//     const [editedCity, setEditedCity] = useState('');

//     const handleEdit = (index) => {
//         setEditIndex(index);
//         setEditedCity(altArr[index]);
//     };

//     const handleSave = (index) => {
//         // setLoadingSav(true)
//         const updatedCities = [...altArr];
//         updatedCities[index] = editedCity;
//         setAltArr(updatedCities);
//         // setEditIndex(null);
//         editAlternativeJobTit(updatedCities)
//     };

//     const handleCityChange = (event) => {
//         setEditedCity(event.target.value);
//     };

//     const tablebg = 'rgba(82, 130, 190, 0.08)';

//     const [open, setOpen] = useState(false);

//     const handleOpen = () => {
//         setOpen(true);
//     };

//     const handleClose = () => {
//         setOpen(false);
//     };

//     const [inputValue, setInputValue] = useState('');

//     const handleInputChange = (e) => {
//         setInputValue(e.target.value);
//     };

//     //   const handleAddButtonClick = () => {
//     //     if (inputValue.trim()) {

//     //       console.log("Input value: ", inputValue);
//     //       setInputValue(''); 
//     //     }
//     //   };

//     const [loadingAdd, setLoadingAdd] = useState(false)
//     const [loadingSav, setLoadingSav] = useState(false)
//     const addAlternativeJobTit = () => {
//         // setAltArr([...altArr, inputValue]);
//         setLoadingAdd(true)
//         const body = {
//             "jobTitle_id": altJobId,
//             "alternateJobTitle": inputValue?.trim()
//         }
//         const token = localStorage.getItem('token');
//         Api(`common/addAlternateJobTitle`, 'POST', body, token)
//             .then((response) => {

//                 console.log("response.data.code", response)
//                 if (response.data.code === 404) {
//                     toast.warn("Alternate job title already Exist!");
//                     setLoadingAdd(false)
//                     handleClose()
//                     setInputValue('')
//                 }
//                 else {
//                     // getSkillTitles();
//                     // alert(response.message)
//                     // toast.success(response.message);
//                     setAltArr([...altArr, inputValue]);
//                     setLoadingAdd(false)
//                     toast.success("Alternative job title added successfully!");
//                     // getCompanyTitles()
//                     // setSelectedType("company")

//                     handleClose()
//                     setInputValue('')
//                     // handleCloseModal()
//                     getJobTitles()
//                 }
//             })
//             .catch((err) => {
//                 console.error(err);
//             });
//     };


//     const editAlternativeJobTit = (updatedCities) => {
//         setLoadingSav(true)
//         const body = {
//             "jobTitle_id": altJobId,
//             "NewJobTitleArray": updatedCities?.trim()
//         }
//         const token = localStorage.getItem('token');
//         Api(`common/editAlternateJobTitle`, 'POST', body, token)
//             .then((response) => {
//                 if (response.status === 200) {
//                     setLoadingSav(false)
//                     setEditIndex(null);
//                     // getSkillTitles();
//                     // alert(response.message)
//                     // toast.success(response.message);
//                     toast.success("Alternative job title updated successfully!");
//                     // getCompanyTitles()
//                     // setSelectedType("company")
//                     // handleClose()
//                     // setInputValue('')
//                     // handleCloseModal()
//                     getJobTitles()
//                 }
//             })
//             .catch((err) => {
//                 console.error(err);
//             });
//     };

//     // console.log("altArr", altArr)
//     const [checkedItems, setCheckedItems] = useState({});

//     const handleCheckboxClick = (item) => {
//         setCheckedItems((prevState) => {
//             const newCheckedItems = { ...prevState };
//             if (newCheckedItems[item._id]) {
//                 delete newCheckedItems[item._id];
//             } else {
//                 newCheckedItems[item._id] = item;
//             }
//             return newCheckedItems;
//         });
//     };


//     const moveToMultiple = (btn) => {
//         // console.log("btn", btn) 
//         data.forEach(item => {
//             if (checkedItems[item._id]) {
//                 if (btn === "job") {
//                     moveToJobTitle(item)
//                 } else if (btn === "skill") {
//                     moveToSkill(item)
//                 } else if (btn === "company") {
//                     moveToCompany(item)
//                 }
//             }
//         });
//         setCheckedItems({})
//     }

//     const deleteMultiple = () => {
//         // console.log("btn", btn) 
//         data.forEach(item => {
//             if (checkedItems[item._id]) {
//                 // if(btn === "job"){
//                 //     moveToJobTitle(item)
//                 // } else if (btn === "skill"){
//                 //     moveToSkill(item)  
//                 // } else if (btn === "company"){
//                 //     moveToCompany(item)
//                 // }

//                 if (softDelete === "job") {
//                     softdeleteJobTitle(item)
//                     // alert("title")
//                 } else if (softDelete === "skill") {
//                     softdeleteSkillTitle(item)
//                     // alert("skill")
//                 } else if (softDelete === "company") {
//                     softdeleteCompanyTitle(item)
//                     // alert("company")
//                 }

//             }
//         });
//         setCheckedItems({})
//     }

//     const clearData = () => {
//         setAddTitle('');
        
//         if (selectedType === 'job') {
//             getJobTitles();
//         } else if (selectedType === 'skill') {
//             getSkillTitles();
//         } else if (selectedType === 'company') {
//             getCompanyTitles();
//         } else if (selectedType === 'deletedskills') {
//             getSoftDeletedSkillsLst();
//         } else if (selectedType === 'deletedjobtitles') {
//             getJobTitlesLst();
//         } else if (selectedType === 'deletedcompanies') {
//             getSoftDeletedCompsLst();
//         }
//     };    

//     const commonSearch = () => {
//         setLoading("Loading...")
//         setData([])

//         if (selectedType === 'job') {
//             setAddJobTitle(addJobTitle);
//         } else if (selectedType === 'skill') {
//             setAddSkillTitle(addSkillTitle);
//         } else if (selectedType === 'company') {
//             setAddCompanyTitle(addCompanyTitle);
//         } else if (selectedType === 'deletedcompanies') {
//             setAddCompanyTitle(addCompanyTitle);
//         } else if (selectedType === 'deletedskills') {
//             setAddSkillTitle(addSkillTitle);
//         } else if (selectedType === 'deletedjobtitles') {
//             setAddJobTitle(addJobTitle);
//         }        

//         const status = ['job', 'skill', 'company'].includes(selectedType) ? 'active' : 'inactive';

//         const body = { 
//             "company": addCompanyTitle || '',
//             "skill": addSkillTitle ? [addSkillTitle] : [],
//             "jobTitle": addJobTitle || ""
//         }
//         const token = localStorage.getItem('token');
//         Api(`company/searchInMasterData/${status}`, 'POST', body, token)
//             .then((response) => {
//                 console.log("repo=======>>>>>>>>", response.data.status)
//                 if (response.status === 200) {
//                     if (response.data.status === 200) {
//                         setLoading('')
//                         // setData(response.data?.searchData)
//                         if (selectedType === 'job') {
//                             setData(response.data?.searchData);
//                         } else if (selectedType === 'skill') {
//                             setData(response.data?.searchData);
//                         } else if (selectedType === 'company') {
//                             setData(response.data?.searchData);
//                         } else if (selectedType === 'deletedcompanies') {
//                             setData(response.data?.searchData);
//                         } else if (selectedType === 'deletedskills') {
//                             setData(response.data?.searchData);
//                         } else if (selectedType === 'deletedjobtitles') {
//                             setData(response.data?.searchData);
//                         }
                        
//                     }
//                     // getJobTitles()
//                 } else {
//                     setLoading("No data found")
//                 }
//             })
//             .catch((err) => {
//                 console.error(err);
//             });
//     };

//     const renderTable = (data) => (
//         <TableContainer component={Paper}>
//             <Table sx={{ minWidth: 600, backgroundColor: 'white' }}>
//                 <TableBody>
//                     { data && data?.map((item) => (
//                         <>
//                             <TableRow key={item._id} sx={{ backgroundColor: '#EFF4FB', marginBottom: 2 }}>
//                                 {(selectedType === 'job' ||
//                                     selectedType === 'skill' ||
//                                     selectedType === 'company') && (



//                                         <FormControlLabel
//                                             sx={{ ml: 0.5, mt: -2 }}
//                                             control={
//                                                 checkedItems[item._id] ? (
//                                                     <Iconify
//                                                         icon="ri:checkbox-circle-line"
//                                                         color="#1976d2"
//                                                         // width="900"
//                                                         // height="900"
//                                                         width="1.6rem"
//                                                         onClick={() => handleCheckboxClick(item)}
//                                                     // disabled={(item.jobTitleStatus !== "new" || item.skillStatus !== 'new' || item.companyNameStatus !== 'new')}
//                                                     // sx={{
//                                                     //   cursor: (item.jobTitleStatus !== "new" || item.skillStatus !== 'new' || item.companyNameStatus !== 'new') 
//                                                     //     ? 'not-allowed' 
//                                                     //     : 'pointer',
//                                                     // }}
//                                                     />
//                                                 ) : (
//                                                     <Iconify
//                                                         icon="ri:checkbox-blank-circle-line"
//                                                         width="1.6rem"
//                                                         // height="900"
//                                                         color="#1976d2"
//                                                         onClick={() => handleCheckboxClick(item)}
//                                                     // disabled={(item.jobTitleStatus !== "new" || item.skillStatus !== 'new' || item.companyNameStatus !== 'new')}
//                                                     // sx={{
//                                                     //   cursor: (item.jobTitleStatus !== "new" || item.skillStatus !== 'new' || item.companyNameStatus !== 'new') 
//                                                     //     ? 'not-allowed' 
//                                                     //     : 'pointer',
//                                                     // }}
//                                                     />
//                                                 )
//                                             }
//                                         />
//                                     )}
//                                 <TableCell sx={{
//                                     color: (item.jobTitleStatus === "new" ||
//                                         item.skillStatus === 'new' ||
//                                         item.companyNameStatus === 'new') && (selectedType === 'job' ||
//                                             selectedType === 'skill' || selectedType === 'company')
//                                         ? "red"
//                                         : '#327CC0',

//                                     fontWeight: 'bold',
//                                     textTransform: "capitalize",
//                                     cursor: selectedType === 'job' ? 'pointer' : ''
//                                 }}
//                                     onClick={() => {

//                                         if (selectedType === 'job' && !isEditing) {
//                                             handleOpenModal(item.alternateJobTitle, item._id);
//                                         }
//                                     }}
//                                 >

//                                     {isEditing && titleId === item._id ? (
//                                         <TextField
//                                             size="small"
//                                             value={editedTitle}
//                                             onChange={(event) => setEditedTitle(event.target.value)}
//                                         />
//                                     ) : (

//                                         selectedType === 'job' ? item?.jobTitle :
//                                             selectedType === 'skill' ? item?.skillName :
//                                                 selectedType === 'company' ? item?.companyName?.charAt(0)?.toUpperCase() + item?.companyName?.slice(1)?.toLowerCase() :
//                                                     selectedType === 'deletedskills' ? item?.skillName :
//                                                         selectedType === 'deletedjobtitles' ? item?.jobTitle :
//                                                             item?.companyName?.charAt(0)?.toUpperCase() + item?.companyName?.slice(1)?.toLowerCase()
//                                     )?.length > 75 ? (

//                                         `${(selectedType === 'job' ? item?.jobTitle :
//                                             selectedType === 'skill' ? item?.skillName :
//                                                 selectedType === 'company' ? item?.companyName :
//                                                     selectedType === 'deletedskills' ? item?.skillName :
//                                                         selectedType === 'deletedjobtitles' ? item?.jobTitle :
//                                                             item?.companyName?.charAt(0)?.toUpperCase() + item?.companyName?.slice(1)?.toLowerCase())?.slice(0, 75)}...`
//                                     ) : (

//                                         selectedType === 'job' ? item?.jobTitle :
//                                             selectedType === 'skill' ? item?.skillName :
//                                                 selectedType === 'company' ? item?.companyName?.charAt(0)?.toUpperCase() + item?.companyName?.slice(1)?.toLowerCase() :
//                                                     selectedType === 'deletedskills' ? item?.skillName :
//                                                         selectedType === 'deletedjobtitles' ? item?.jobTitle :
//                                                             item?.companyName?.charAt(0)?.toUpperCase() + item?.companyName?.slice(1)?.toLowerCase()
//                                     )}
//                                 </TableCell>

//                                 {data && (
//                                     <TableCell sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>

//                                         {isEditing && titleId === item._id ? (
//                                             <Button
//                                                 variant="contained"
//                                                 sx={{
//                                                     color: 'white',
//                                                     backgroundColor: 'text.secondary',
//                                                     boxShadow: 'none',
//                                                     '&:hover': {
//                                                         backgroundColor: 'text.secondary',
//                                                     },
//                                                 }}
//                                                 onClick={handleSaveClick}
//                                             >
//                                                 Save
//                                             </Button>
//                                         ) : (
//                                             selectedType === 'job' ? (

//                                                 <>
//                                                     {/* {item.jobTitleStatus === "new" && (

//                                                         <Button
//                                                             variant="contained"
//                                                             sx={{
//                                                                 color: 'white',
//                                                                 backgroundColor: 'text.secondary',
//                                                                 boxShadow: 'none'

//                                                             }}
//                                                             onClick={() => moveToJobTitle(item._id, item.jobTitle
//                                                             )}
//                                                             disabled={isEditing}
//                                                         >
//                                                             Move To Job Title
//                                                         </Button>
//                                                     )} */}
//                                                     {/* <Button
//                                                         variant="contained"
//                                                         sx={{
//                                                             color: 'white',
//                                                             backgroundColor: 'text.secondary',
//                                                             boxShadow: 'none',
//                                                             '&:hover': {
//                                                                 backgroundColor: 'text.secondary',
//                                                             },
//                                                         }}
//                                                         onClick={() => handleEditClick(item._id, item.jobTitle)}
//                                                         disabled={isEditing}
//                                                     >
//                                                         Edit
//                                                     </Button> */}
//                                                     {/* <IconButton onClick={() => handleEditClick(item._id, item.jobTitle)}> */}
//                                                     <Iconify onClick={() => handleEditClick(item._id, item.jobTitle)}
//                                                         icon="mingcute:edit-line" width="1.6rem" color='#3C6BA5' />
//                                                     {/* </IconButton> */}
//                                                     {/* <Button
//                                                 variant="contained"
//                                                 sx={{
//                                                     color: 'white',
//                                                     backgroundColor: 'error.main',
//                                                     boxShadow: 'none',
//                                                     '&:hover': {
//                                                         backgroundColor: 'error.main',
//                                                     },
//                                                 }}
//                                                 onClick={() => openDeleteModal(item._id)}
//                                             >
//                                                 Delete
//                                             </Button> */}


//                                                     {/* <Button
//                                                         variant="contained"
//                                                         sx={{
//                                                             color: 'white',
//                                                             backgroundColor: 'error.main',
//                                                             boxShadow: 'none',
//                                                             '&:hover': {
//                                                                 backgroundColor: 'error.main',
//                                                             },
//                                                         }}
//                                                         onClick={() => openDeleteModal(item._id, "softdeletetitle")}
//                                                     >
//                                                         Delete
//                                                     </Button> */}
//                                                     {/* <IconButton onClick={() => openDeleteModal(item._id, "softdeletetitle")}> */}
//                                                     {/* <Iconify onClick={() => openDeleteModal(item._id, "softdeletetitle")}
//                                                         icon="weui:delete-on-filled" width="1.6rem" color="red" /> */}
//                                                     {/* </IconButton> */}
//                                                 </>
//                                             ) : selectedType === 'skill' ? (
//                                                 <>

//                                                     {/* {item.skillStatus === 'new' && (
//                                                         <Button
//                                                             variant="contained"
//                                                             sx={{
//                                                                 color: 'white',
//                                                                 backgroundColor: 'text.secondary',
//                                                                 boxShadow: 'none'
//                                                             }}
//                                                             onClick={() => moveToSkill(item._id, item.skillName)}
//                                                             disabled={isEditing}
//                                                         >
//                                                             Move To Skill
//                                                         </Button>
//                                                     )} */}
//                                                     {/* <Button
//                                                         variant="contained"
//                                                         sx={{
//                                                             color: 'white',
//                                                             backgroundColor: 'text.secondary', boxShadow: 'none'
//                                                         }}
//                                                         onClick={() => handleEditClick(item._id, item.skillName)}
//                                                         disabled={isEditing}
//                                                     >
//                                                         Edit
//                                                     </Button> */}
//                                                     {/* <IconButton onClick={() => handleEditClick(item._id, item.skillName)}> */}
//                                                     <Iconify onClick={() => handleEditClick(item._id, item.skillName)}
//                                                         icon="mingcute:edit-line" width="1.6rem" color='#3C6BA5' />
//                                                     {/* </IconButton> */}

//                                                     {/* <Button
//                                                     variant="contained"
//                                                     sx={{
//                                                         color: 'white',
//                                                         backgroundColor: 'error.main',
//                                                         boxShadow: 'none'
//                                                     }}
//                                                     onClick={() => openDeleteModal(item._id)}
//                                                 >
//                                                     Delete
//                                                 </Button> */}
//                                                     {/* {selectedType === 'skill' && (
//                                                         // <Button
//                                                         // variant="contained"
//                                                         // sx={{
//                                                         //     color: 'white',
//                                                         //     backgroundColor: 'error.main',
//                                                         //     boxShadow: 'none',
//                                                         //     '&:hover': {
//                                                         //         backgroundColor: 'error.main',
//                                                         //     },
//                                                         // }}
//                                                         //     onClick={() => openDeleteModal(item._id, "softdeleteskill")}
//                                                         // >
//                                                         //     Delete
//                                                         // </Button>
//                                                         // <IconButton onClick={() => openDeleteModal(item._id, "softdeleteskill")}>
//                                                         // </IconButton>
//                                                         <Iconify onClick={() => openDeleteModal(item._id, "softdeleteskill")}
//                                                             icon="weui:delete-on-filled" width="1.6rem" color="red" />
//                                                     )} */}

//                                                 </>
//                                             ) : (
//                                                 <>
//                                                     {selectedType === "company" && (
//                                                         <>
//                                                             {/* <Button
//                                                                 variant="contained"
//                                                                 sx={{ color: 'white', backgroundColor: 'text.secondary', boxShadow: 'none' }}
//                                                                 onClick={() => handleEditClick(item._id, item.companyName)}
//                                                                 disabled={isEditing}
//                                                             >
//                                                                 Edit
//                                                             </Button> */}
//                                                             {/* {item.companyNameStatus === 'new' && (
//                                                                 <Button
//                                                                     variant="contained"
//                                                                     sx={{ color: 'white', backgroundColor: 'text.secondary', boxShadow: 'none' }}
//                                                                     onClick={() => moveToCompany(item._id, item.companyName)}
//                                                                     disabled={isEditing}
//                                                                 >
//                                                                     Move To Company
//                                                                 </Button>
//                                                             )} */}
//                                                             {/* <IconButton onClick={() => handleEditClick(item._id, item.companyName)}> */}
//                                                             <Iconify onClick={() => handleEditClick(item._id, item.companyName)}
//                                                                 icon="mingcute:edit-line" width="1.6rem" color='#3C6BA5' />
//                                                             {/* </IconButton> */}

//                                                         </>
//                                                     )}

//                                                     {/* <Button
//                                                 variant="contained"
//                                                 sx={{ color: 'white', backgroundColor: 'error.main', boxShadow: 'none' }}
//                                                 onClick={() => openDeleteModal(item._id)}
//                                             >
//                                                 Delete
//                                             </Button> */}
//                                                     {/* {selectedType === 'company' && (
//                                                         // <Button
//                                                         // variant="contained"
//                                                         // sx={{
//                                                         //     color: 'white',
//                                                         //     backgroundColor: 'error.main',
//                                                         //     boxShadow: 'none',
//                                                         //     '&:hover': {
//                                                         //         backgroundColor: 'error.main',
//                                                         //     },
//                                                         // }}
//                                                         //     onClick={() => openDeleteModal(item._id, "softdeletecompany")}
//                                                         // >
//                                                         //     Delete
//                                                         // </Button>
//                                                         // <IconButton onClick={() => openDeleteModal(item._id, "softdeletecompany")}>
//                                                         <Iconify onClick={() => openDeleteModal(item._id, "softdeletecompany")}
//                                                             icon="weui:delete-on-filled" width="1.6rem" color="red" />
//                                                         // </IconButton>
//                                                     )} */}
//                                                     {selectedType === 'deletedskills' &&
//                                                         item.skillStatus === 'new' && (
//                                                             <>
//                                                                 <Button
//                                                                     variant="contained"
//                                                                     sx={{ color: 'white', backgroundColor: 'text.secondary', boxShadow: 'none' }}
//                                                                     onClick={() => softdeleteSkillMove(item._id)}
//                                                                 // disabled={isEditing}
//                                                                 >
//                                                                     Move to Skill
//                                                                 </Button>

//                                                                 {/* <Button 
//                                                     variant="contained"
//                                                     sx={{ color: 'white', backgroundColor: 'text.secondary', boxShadow: 'none' }}
//                                                     // onClick={() => moveToCompany(item._id, item.companyName)}
//                                                     // disabled={isEditing}
//                                                 >
//                                                     Record
//                                                 </Button> */}
//                                                                 <IconButton
//                                                                     sx={{
//                                                                         // position:"absolute",
//                                                                         width: 30,
//                                                                         height: 30,
//                                                                         // ml: 9,
//                                                                         // mt: -3.8,
//                                                                         backgroundColor: 'lightgrey',
//                                                                         borderRadius: '50%',
//                                                                         padding: 0,
//                                                                         '&:hover': {
//                                                                             backgroundColor: 'grey',
//                                                                         },
//                                                                     }}
//                                                                 >
//                                                                     {item?.record?.length || '0'}
//                                                                 </IconButton>
//                                                             </>
//                                                         )}

//                                                     {selectedType === 'deletedjobtitles' &&

//                                                         <>
//                                                             {item.jobTitleStatus === "new" && (

//                                                                 <Button
//                                                                     variant="contained"
//                                                                     sx={{ color: 'white', backgroundColor: 'text.secondary', boxShadow: 'none' }}
//                                                                     onClick={() => softdeleteJobTitleMoveTo(item._id)}
//                                                                 // disabled={isEditing}
//                                                                 >
//                                                                     Move to Job Title
//                                                                 </Button>
//                                                             )}
//                                                             <IconButton
//                                                                 sx={{
//                                                                     // position:"absolute",
//                                                                     width: 30,
//                                                                     height: 30,
//                                                                     // ml: 9,
//                                                                     // mt: -3.8,
//                                                                     backgroundColor: 'lightgrey',
//                                                                     borderRadius: '50%',
//                                                                     padding: 0,
//                                                                     '&:hover': {
//                                                                         backgroundColor: 'grey',
//                                                                     },
//                                                                 }}
//                                                             >
//                                                                 {item?.record?.length || '0'}
//                                                             </IconButton>
//                                                         </>

//                                                     }
//                                                     {selectedType === 'deletedcompanies' &&
//                                                         item.companyNameStatus === 'new' && (
//                                                             <>
//                                                                 <Button
//                                                                     variant="contained"
//                                                                     sx={{ color: 'white', backgroundColor: 'text.secondary', boxShadow: 'none' }}
//                                                                     onClick={() => softdeleteCompMove(item._id)}
//                                                                 // disabled={isEditing}
//                                                                 >
//                                                                     Move to Company
//                                                                 </Button>
//                                                                 <IconButton
//                                                                     sx={{
//                                                                         // position:"absolute",
//                                                                         width: 30,
//                                                                         height: 30,
//                                                                         // ml: 9,
//                                                                         // mt: -3.8,
//                                                                         backgroundColor: 'lightgrey',
//                                                                         borderRadius: '50%',
//                                                                         padding: 0,
//                                                                         '&:hover': {
//                                                                             backgroundColor: 'grey',
//                                                                         },
//                                                                     }}
//                                                                 >
//                                                                     {item?.record?.length || '0'}
//                                                                 </IconButton>
//                                                             </>
//                                                         )}
//                                                 </>
//                                             )
//                                         )}
//                                     </TableCell>
//                                 )}
//                             </TableRow>
//                             <TableCell />
//                         </>
//                     ))}
//                 </TableBody>
//             </Table>
//         </TableContainer>
//     );

//     return (
//         <Stack>
//             <ToastContainer />
//             <Typography variant="h5" color="text.secondary" sx={{ marginBottom: '6px' }}>
//                 Master Data
//             </Typography>
//             <Stack sx={{ flexDirection: "row", gap: "10px", marginBottom: "10px" }}>
//                 <Typography
//                     sx={{
//                         backgroundColor: selectedType === 'job' ? 'secondary.main' : 'text.secondary',
//                         color: 'white',
//                         padding: 1,
//                         borderRadius: "5px",
//                         cursor: "pointer"
//                     }}
//                     onClick={() => {
//                         setSelectedType('job')
//                         setAddJobTitle('')
//                         setAddSkillTitle('')
//                         setAddCompanyTitle('')
//                         setAddTitle('')
//                     }
//                     }
//                 >
//                     Job Titles
//                 </Typography>
//                 <Typography
//                     sx={{
//                         backgroundColor: selectedType === 'skill' ? 'secondary.main' : 'text.secondary',
//                         color: 'white',
//                         padding: 1,
//                         borderRadius: "5px",
//                         cursor: "pointer"
//                     }}
//                     onClick={() => {
//                         setSelectedType('skill')
//                         setAddJobTitle('')
//                         setAddSkillTitle('')
//                         setAddCompanyTitle('')
//                         setAddTitle('')
//                     }
//                     }
//                 >
//                     Skills
//                 </Typography>
//                 <Typography
//                     sx={{
//                         backgroundColor: selectedType === 'company' ? 'secondary.main' : 'text.secondary',
//                         color: 'white',
//                         padding: 1,
//                         borderRadius: "5px",
//                         cursor: "pointer"
//                     }}
//                     onClick={() => {
//                         setSelectedType('company')
//                         setAddJobTitle('')
//                         setAddSkillTitle('')
//                         setAddCompanyTitle('')
//                         setAddTitle('')
//                     }
//                     }
//                 >
//                     Companies
//                 </Typography>
//                 <Typography
//                     sx={{
//                         backgroundColor: selectedType === 'deletedjobtitles' ? 'secondary.main' : 'text.secondary',
//                         color: 'white',
//                         padding: 1,
//                         borderRadius: "5px",
//                         cursor: "pointer"
//                     }}
                   
//                     onClick={() => {
//                         setSelectedType('deletedjobtitles')
//                         setAddJobTitle('')
//                         setAddSkillTitle('')
//                         setAddCompanyTitle('')
//                         setAddTitle('')
//                     }
//                 }
//                 >
//                     Deleted Job Titles
//                 </Typography>
//                 <Typography
//                     sx={{
//                         backgroundColor: selectedType === 'deletedskills' ? 'secondary.main' : 'text.secondary',
//                         color: 'white',
//                         padding: 1,
//                         borderRadius: "5px",
//                         cursor: "pointer"
//                     }}
                   
//                     onClick={() => {
//                         setSelectedType('deletedskills')
//                         setAddJobTitle('')
//                         setAddSkillTitle('')
//                         setAddCompanyTitle('')
//                         setAddTitle('')
//                     }
//                 }
//                 >
//                     Deleted Skills
//                 </Typography>
//                 <Typography
//                     sx={{
//                         backgroundColor: selectedType === 'deletedcompanies' ? 'secondary.main' : 'text.secondary',
//                         color: 'white',
//                         padding: 1,
//                         borderRadius: "5px",
//                         cursor: "pointer"
//                     }}
                  
//                     onClick={() => {
//                         setSelectedType('deletedcompanies')
//                         setAddJobTitle('')
//                         setAddSkillTitle('')
//                         setAddCompanyTitle('')
//                         setAddTitle('')
//                     }
//                 }
//                 >
//                     Deleted Companies
//                 </Typography>
//             </Stack>
//             <Grid container spacing={1} alignItems="center" sx={{ marginTop: '-14px', marginBottom: '7px' }}>
//                 <Grid item xs={2}>
//                     <TextField
//                        label={
//                         selectedType === 'job' ? 'Job Title' :
//                         selectedType === 'skill' ? 'Skill' :
//                         selectedType === 'company' ? 'Company Name' :
//                         selectedType === 'deletedcompanies' ? 'Deleted Company Name' :
//                         selectedType === 'deletedskills' ? 'Deleted Skill' :
//                          'Deleted Job Title' 
                        
//                       }                      
//                         variant="outlined"
//                         fullWidth
//                         margin="normal"
//                         size="small"
//                         value={addTitle()}
//                         onChange={(e) => setAddTitle(e.target.value)}
//                         InputProps={{ style: { borderRadius: '7px', paddingLeft: '10px' } }}
//                         InputLabelProps={{ style: { marginLeft: '1px' } }}
//                     />

//                     {/* <TextField
//                         variant="outlined"
//                         fullWidth
//                         margin="normal"
//                         size="small"
//                         value={inputData}
//                         onChange={(e) => setInputData(e.target.value)}
                       
//                     /> */}

//                 </Grid>
//                 <Grid item xs={1}>
//                     <Button
//                         fullWidth
//                         color="custom"
//                         variant="contained"
//                         // disabled={!addTitle()}
//                         disabled={
//                             !addTitle() 
//                             // &&
//                             // ["deletedcompanies", "deletedskills", "deletedjobtitles"].includes(selectedType)
                            
//                           }
//                         onClick={addTitleFunc}
//                         style={{
//                             backgroundColor: 'text.secondary',
//                             color: 'white',
//                             borderRadius: '7px',
//                             height: '35px',
//                             marginTop: '8px',
//                         }}
//                     >
//                         Add New
//                     </Button>
//                 </Grid>

//                 <Grid item xs={1}>
//                     <Button
//                         fullWidth
//                         color="custom"
//                         variant="contained"
//                         disabled={!addTitle()}
//                         onClick={commonSearch}
//                         style={{
//                             backgroundColor: 'text.secondary',
//                             color: 'white',
//                             borderRadius: '7px',
//                             height: '35px',
//                             marginTop: '8px',
//                         }}
//                     >
//                         Search
//                     </Button>
//                 </Grid>

//                 <Grid item xs={1}>
//                     <Button
//                         fullWidth
//                         color="custom"
//                         variant="contained"
//                         disabled={!addTitle()}
//                         onClick={clearData}
//                         style={{
//                             backgroundColor: 'text.secondary',
//                             color: 'white',
//                             borderRadius: '7px',
//                             height: '35px',
//                             marginTop: '8px',
//                         }}
//                     >
//                         Clear
//                     </Button>
//                 </Grid>

//                 <Grid container justifyContent="flex-end" sx={{ marginTop: '-14px', marginBottom: '7px' }}>
//                     {(selectedType === 'job' || selectedType === "company" || selectedType === "skill") && (
//                         <>
//                             <Button
//                                 color="custom"
//                                 variant="contained"
//                                 style={{
//                                     backgroundColor: 'text.secondary',
//                                     color: 'white',
//                                     borderRadius: '7px',
//                                     height: '35px',
//                                     marginTop: '-33px',
//                                 }}
//                                 onClick={() => moveToMultiple(selectedType)}
//                             >
//                                 {selectedType === 'job' ? 'Move to Job Title' :
//                                     selectedType === 'skill' ? 'Move to Skill' :
//                                         'Move to Company'}

//                             </Button>
//                             <Button sx={{ ml: 2 }}
//                                 color="custom"
//                                 variant="contained"
//                                 style={{
//                                     backgroundColor: 'text.secondary',
//                                     color: 'white',
//                                     borderRadius: '7px',
//                                     height: '35px',
//                                     marginTop: '-33px',
//                                 }}
//                                 //    onClick={()=>deleteMultiple(selectedType)}
//                                 onClick={() => openDeleteModal(selectedType)}
//                             >
//                                 {selectedType === 'job' ? 'Detele Job Title' :
//                                     selectedType === 'skill' ? 'Delete Skill' :
//                                         'Delete Company'}

//                             </Button>
//                         </>
//                     )}
//                 </Grid>
//             </Grid>
//             {/* <Divider sx={{ mb: 2, borderWidth: 1.7, borderColor: '#3C6BA5'}} /> */}
//             {loading ? (
//                 <Typography sx={{ color: "red", ml: "45%", mt: 4 }}>{loading}</Typography>
//             ) : (
//                 <Stack direction="row" spacing={2}>
//                     {renderTable(splitData.part1)}
//                     {renderTable(splitData.part2)}
//                 </Stack>
//             )}
//             <Modal open={del} onClose={closeDeleteModal} style={{ borderRadius: 10 }}>
//                 <Box sx={[style, { width: '20%' }]}>
//                     <Stack sx={{ justifyContent: 'center', alignContent: 'center', width: '100%' }}>
//                         <Stack sx={{ width: '100%' }}>
//                             <Typography variant="h6" textAlign={'center'} color={'red'}>
//                                 Do you want to delete selected {selectedType === 'job' ? 'job title' :
//                                     selectedType === 'skill' ? 'skill' :
//                                         'company'
//                                 } ?
//                             </Typography>
//                         </Stack>
//                         <Stack sx={{ flexDirection: 'row', justifyContent: 'space-between', width: '25%', mt: 3, alignSelf: 'center' }}>
//                             <Button
//                                 color="custom"
//                                 variant="contained"
//                                 size="small"
//                                 onClick={() => {
//                                     deleteMultiple(); closeDeleteModal()
//                                     // if (softDelete) { deleteTitleFunc1(); closeDeleteModal()}
//                                     // else {
//                                     //     closeDeleteModal();deleteTitleFunc(); 
//                                     // }
//                                 }}
//                             >
//                                 Yes
//                             </Button>
//                             <Button color="custom" variant="contained" size="small" onClick={closeDeleteModal}>
//                                 No
//                             </Button>
//                         </Stack>
//                     </Stack>
//                 </Box>
//             </Modal>

//             <Modal open={open} onClose={handleClose}>
//                 <Box
//                     sx={{
//                         position: 'absolute',
//                         top: '50%',
//                         left: '50%',
//                         transform: 'translate(-50%, -50%)',
//                         width: "35%",
//                         bgcolor: 'background.paper',
//                         border: '2px solid #3C6BA5',
//                         boxShadow: 24,
//                         p: 3,
//                         borderRadius: 2,
//                     }}>
//                     <Stack sx={{ justifyContent: 'center', alignContent: 'center', width: '100%' }}>
//                         <Typography
//                             sx={{
//                                 color: "#3C6BA5",
//                                 fontWeight: 'bold',
//                                 textAlign: 'center',
//                                 fontSize: "20px",
//                                 flexGrow: 1,
//                                 mt: -2
//                             }}
//                         >
//                             Alternative Job Title
//                         </Typography>
//                         <Divider sx={{ mt: 1, mb: 1 }} />
//                         <Stack sx={{ width: '100%' }}>
//                             <TextField
//                                 fullWidth
//                                 label="Add Alternative Job Title"
//                                 variant="outlined"
//                                 value={inputValue}
//                                 onChange={handleInputChange}
//                             //   size="small"
//                             />
//                         </Stack>
//                         {/* <Stack sx={{ mt: 2 }}> */}
//                         {/* </Stack> */}
//                     </Stack>
//                     <Grid item xs={6} textAlign="center"
//                         sx={{ mt: 2, height: "24px" }}>
//                         <Button
//                             color="custom" variant="contained" size="small"
//                             disabled={inputValue === '' || loadingAdd}
//                             sx={{
//                                 // color: 'white',
//                                 paddingTop: 0.8,
//                                 paddingBottom: 0.8,
//                                 // mt: 2,
//                                 // alignItems: 'center',
//                                 // backgroundColor: 'text.secondary',
//                                 // boxShadow: 'none',
//                                 // flexShrink: 0,
//                                 // display: 'block', 
//                                 // marginLeft: 'auto',  
//                                 // marginRight: 'auto', 
//                                 // '&:hover': {
//                                 //   backgroundColor: 'text.secondary',
//                                 //   boxShadow: 'none', 
//                                 // },
//                             }}
//                             onClick={() => addAlternativeJobTit()}
//                         >
//                             {/* Add */}
//                             {loadingAdd ? <CircularProgress size={22} /> : 'Add'}
//                         </Button>
//                     </Grid>

//                 </Box>
//             </Modal>

//             <Popover
//                 open={modalOpen}
//                 onClose={handleCloseModal}
//                 anchorOrigin={{
//                     vertical: 'center',
//                     horizontal: 'center',
//                 }}
//                 transformOrigin={{
//                     vertical: 'center',
//                     horizontal: 'center',
//                 }}
//                 PaperProps={{
//                     style: {
//                         border: '1px solid #3C6BA5',
//                         boxShadow: '24',
//                     },
//                 }}
//             >
//                 <Box
//                     sx={{
//                         width: '80vh',
//                         height: '80vh',
//                         bgcolor: 'background.paper',
//                         p: 2,
//                         borderRadius: 1,
//                         display: 'flex',
//                         flexDirection: 'column',
//                     }}
//                 >
//                     <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
//                         <Typography
//                             sx={{
//                                 color: "#3C6BA5",
//                                 fontWeight: 'bold',
//                                 textAlign: 'center',
//                                 fontSize: "20px",
//                                 flexGrow: 1,
//                             }}
//                         >
//                             Alternative Job Title List
//                         </Typography>
//                         <Button
//                             variant="contained"
//                             sx={{
//                                 color: 'white', backgroundColor: 'text.secondary',
//                                 boxShadow: 'none',
//                                 '&:hover': {
//                                     backgroundColor: 'text.secondary',
//                                     boxShadow: 'none',

//                                 }
//                             }}
//                             onClick={() => handleOpen()}>
//                             Add

//                         </Button>

//                     </Box>

//                     <Divider sx={{ mt: 2, mb: 2 }} />
//                     <Box
//                         sx={{
//                             overflowY: 'auto',
//                             height: '80vh',
//                             flexGrow: 1,
//                             '&:hover': {
//                                 overflowY: 'auto',
//                             },
//                             scrollbarWidth: 'thin',
//                             '&::-webkit-scrollbar': {
//                                 width: '8px',
//                             },
//                             '&::-webkit-scrollbar-thumb': {
//                                 backgroundColor: '#888',
//                                 borderRadius: '4px',
//                             },
//                             '&::-webkit-scrollbar-thumb:hover': {
//                                 backgroundColor: '#555',
//                             },
//                             paddingRight: '16px',
//                         }}
//                     >
//                         {(altArr?.length === 0) ? (

//                             <Typography sx={{ color: "red", textAlign: "center" }}>No data found</Typography>
//                         ) : (
//                             // altArr?.filter((_, index) => index !== "" && index !== undefined)?.map((city, index) => (
//                             altArr?.map((city, index) => (

//                                 <Box
//                                     sx={[
//                                         {
//                                             display: 'flex',
//                                             alignItems: 'center',
//                                             marginBottom: 1,
//                                             background: index % 2 === 0 ? 'text.background' : tablebg,
//                                             '&:last-child td, &:last-child th': { border: 0 },
//                                             // '&:hover': { boxShadow: 5 }, 
//                                         },
//                                     ]}
//                                     key={index}
//                                 >
//                                     {editIndex === index ? (
//                                         <TextField
//                                             variant="outlined"
//                                             // margin="normal"
//                                             size="small"
//                                             value={editedCity}
//                                             onChange={handleCityChange}
//                                             sx={{ width: '70%', m: 0.7 }}
//                                         />
//                                     ) : (
//                                         <Typography sx={{ flexGrow: 1, m: 0.9 }}>{city}</Typography>
//                                     )}

//                                     <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', width: '30%' }}>
//                                         {editIndex === index ? (
//                                             <Button
//                                                 variant="contained"
//                                                 disabled={!editedCity || loadingSav}
//                                                 sx={{
//                                                     color: 'white',
//                                                     backgroundColor: 'text.secondary',
//                                                     boxShadow: 'none',
//                                                     flexShrink: 0,
//                                                     '&:hover': {
//                                                         backgroundColor: 'text.secondary',
//                                                         boxShadow: 'none',
//                                                     },
//                                                 }}
//                                                 onClick={() => handleSave(index)}
//                                             >
//                                                 {loadingSav ? <CircularProgress size={21} sx={{ color: 'white' }} /> : 'Save'}
//                                             </Button>
//                                         ) : (
//                                             (city !== "" && city !== 0) && (
//                                                 <Button
//                                                     sx={{
//                                                         color: 'white',
//                                                         backgroundColor: 'text.secondary',
//                                                         boxShadow: 'none',
//                                                         flexShrink: 0,
//                                                         '&:hover': {
//                                                             backgroundColor: 'text.secondary',
//                                                             boxShadow: 'none',
//                                                         },
//                                                     }}
//                                                     onClick={() => handleEdit(index)}
//                                                 >
//                                                     Edit
//                                                 </Button>
//                                             )
//                                         )}
//                                     </Box>

//                                 </Box>
//                             ))
//                         )}

//                     </Box>
//                 </Box>
//             </Popover>

//         </Stack>
//     );
// };

// export default MasterData;

import React, { useState, useEffect } from 'react';
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Stack,
  Button,
  TextField,
  Grid,
  Modal,
  Box,
  Divider,
  Badge,
  IconButton,
  Popover,
  FormControlLabel,
  CircularProgress,
} from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Helmet } from 'react-helmet-async';
 
import { Icon } from '@iconify/react';
import Iconify from '../components/iconify';
import { Api } from '../webservices';
// import Scrollbar from 'src/components/scrollbar/Scrollbar';
import Scrollbar from '../components/scrollbar/Scrollbar';

const MasterData = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedTitle, setEditedTitle] = useState('');
  const [addJobTitle, setAddJobTitle] = useState('');
  const [addSkillTitle, setAddSkillTitle] = useState('');
  const [addCompanyTitle, setAddCompanyTitle] = useState('');
  const [data, setData] = useState([]);
  const [splitData, setSplitData] = useState({ part1: [], part2: [] });
  const [titleId, setTitleId] = useState(null);
  const [selectedType, setSelectedType] = useState('job');
  const [del, setDel] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [softDelete, setSoftDelete] = useState('');
  const [loading, setLoading] = useState(false);
  const [inputData, setInputData] = useState('');
  const openDeleteModal = (actionType) => {
    // setDeleteId(id);
    setSoftDelete(actionType);
    setDel(true);
  };

  const closeDeleteModal = () => {
    setDeleteId(null);
    setDel(false);
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { md: '50%', xs: '95%' },
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 3,
    border: '3px solid #3C6BA5',
    borderRadius: 3,
  };

  useEffect(() => {
    if (selectedType === 'job') {
      getJobTitles();
    } else if (selectedType === 'skill') {
      getSkillTitles();
    } else if (selectedType === 'company') {
      getCompanyTitles();
    } else if (selectedType === 'deletedskills') {
      getSoftDeletedSkillsLst();
    } else if (selectedType === 'deletedjobtitles') {
      getJobTitlesLst();
    } else if (selectedType === 'deletedcompanies') {
      getSoftDeletedCompsLst();
    }
  }, [selectedType]);

  useEffect(() => {
    const half = Math.ceil(data?.length / 2);
    setSplitData({ part1: data?.slice(0, half), part2: data?.slice(half) });
  }, [data]);

  const handleEditClick = (id, currentTitle) => {
    setIsEditing(true);
    setTitleId(id);
    setEditedTitle(currentTitle);
  };

  const handleSaveClick = () => {
    setIsEditing(false);
    if (selectedType === 'job') {
      updateJobTitle(titleId);
    } else if (selectedType === 'skill') {
      updateSkillTitle(titleId);
    } else if (selectedType === 'company') {
      updateCompanyTitle(titleId);
    }
  };

  const getJobTitles = () => {
    setLoading('Loading...');
    setData([]);
    const token = localStorage.getItem('token');
    Api(`common/jobtitle/get/active`, 'GET', '', token)
      .then((response) => {
        if (response.status === 200 && response.data.code === 200) {
          setData(response.data.jobTitles);
          setLoading('');
        } else {
          setLoading('No data found');
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getJobTitlesLst = () => {
    setLoading('Loading...');
    setData([]);

    const token = localStorage.getItem('token');

    Api('common/jobtitle/get/inactive', 'GET', '', token)
      .then((response) => {
        if (response.status === 200 && response.data.code === 200) {
          const jobTitles = response.data.jobTitles;

          if (jobTitles.length === 0) {
            setLoading('No data found');
          } else {
            setData(jobTitles);
            setLoading('');
          }
        } else {
          setLoading('No data found');
        }
      })
      .catch((err) => {
        console.error(err);
        // setLoading('An error occurred');
      });
  };

  const getSkillTitles = () => {
    setData([]);
    setLoading('Loading...');
    const token = localStorage.getItem('token');
    Api(`resume/get_skills/${'masterdata'}`, 'GET', '', token)
      .then((response) => {
        if (response.status === 200 && response.data.code === 200) {
          setData(response.data.result);
          setLoading('');
        } else {
          setLoading('No data found');
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getSoftDeletedSkillsLst = () => {
    setLoading('Loading...');
    setData([]);

    const token = localStorage.getItem('token');

    Api('resume/softDeleteSkillList', 'GET', '', token)
      .then((response) => {
        if (response.status === 200 && response.data.code === 200) {
          const result = response.data.result;

          if (result.length === 0) {
            setLoading('No data found');
          } else {
            setData(result);
            setLoading('');
          }
        } else {
          setLoading('No data found');
        }
      })
      .catch((err) => {
        console.error(err);
        // setLoading('An error occurred');
      });
  };

  const getCompanyTitles = () => {
    setData([]);
    setLoading('Loading...');
    const token = localStorage.getItem('token');
    Api(`common/companyName/get/active`, 'GET', '', token)
      .then((response) => {
        if (response.status === 200 && response.data.code === 200) {
          setData(response.data.companies);
          setLoading('');
        } else {
          setLoading('No data found');
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getSoftDeletedCompsLst = () => {
    setLoading('Loading...');
    setData([]);

    const token = localStorage.getItem('token');
    Api(`common/companyName/get/inactive`, 'GET', '', token)
      .then((response) => {
        if (response.status === 200 && response.data.code === 200) {
          const companies = response.data.companies;

          if (companies.length === 0) {
            setLoading('No data found');
          } else {
            setData(companies);
            setLoading('');
          }
        } else {
          setLoading('No data found');
          // alert('Error fetching data');
        }
      })
      .catch((err) => {
        console.error(err);
        // setLoading('An error occurred');
      });
  };

  const addJobTitleFunc = () => {
    const addJobTitles = addJobTitle.split(',').map((title) => title.trim());
    addJobTitles.forEach((title) => {
      const body = {
        jobTitle: title,
        jobTitleStatus: 'approved',
      };
      const token = localStorage.getItem('token');
      Api(`common/jobtitle/add`, 'POST', body, token)
        .then((response) => {
          if (response.status === 200 && response.data.code === 200) {
            getJobTitles();
            setAddJobTitle('');
            toast.success(`Job title added successfully!`);
          } else {
            toast.error(`Job title already exists!`);
            setAddJobTitle('');
          }
        })
        .catch((err) => {
          console.error(err);
          // toast.error(`Failed to add job title "${title}"`);
        });
    });
  };

  const moveToJobTitle = (id) => {
    const body = {
      jobtitle_id: id._id,
    };
    const token = localStorage.getItem('token');
    Api(`common/moveToJobtitle`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200 && response.data.code === 200) {
          getJobTitles();
          toast.success('job title_id moved successfully!');
        } else {
          toast.error('job title_id already exists!');
        }
      })
      // toast.error("Skill already exists")
      .catch((err) => {
        console.error(err);
      });
  };

  const moveToSkill = (item) => {
    const body = {
      skillName: item.skillName,
      skillStatus: 'approved',
    };
    const token = localStorage.getItem('token');
    Api(`common/skill/update/${item._id}`, 'PUT', body, token)
      .then((response) => {
        if (response.status === 200 && response.data.code === 200) {
          getSkillTitles();
          toast.success('Skill moved successfully!');
        } else {
          toast.error('Skill already exists!');
        }
      })
      // toast.error("Skill already exists")
      .catch((err) => {
        console.error(err);
      });
  };

  const moveToCompany = (item) => {
    const body = {
      companyName: item.companyName,
      companyNameStatus: 'approved',
    };
    const token = localStorage.getItem('token');
    Api(`common/companyName/update/${item._id}`, 'PUT', body, token)
      .then((response) => {
        if (response.status === 200 && response.data.code === 200) {
          getCompanyTitles();
          toast.success('Company moved successfully!');
        } else {
          toast.error('Company already exists!');
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const addSkillTitleFunc = () => {
    const skillTitles = addSkillTitle?.split(',')?.map((skill) => skill?.trim()?.toLowerCase());
    const token = localStorage.getItem('token');

    Promise.all(
      skillTitles?.map((skill) => {
        const body = {
          skillName: skill,
          skillStatus: 'approved', 
        };
        return Api(`common/skill/add`, 'POST', body, token);
      })
    )
      .then((responses) => {
        if (responses.every((response) => response.status === 200 && response.data.code === 200)) {
          getSkillTitles();
          setAddSkillTitle('');
          toast.success('Skill ddded successfully!');
        } else {
          toast.error('Skill already exist!');
          getSkillTitles();
          setAddSkillTitle('');
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const addCompanyTitleFunc = () => {
    const addCompanyTitles = addCompanyTitle.split(',').map((title) => title.trim());
    addCompanyTitles.forEach((title) => {
      const body = {
        companyName: title,
        companyNameStatus: 'approved',
      };
      const token = localStorage.getItem('token');
      Api(`common/companyName/add`, 'POST', body, token)
        .then((response) => {
          if (response.status === 200 && response.data.code === 200) {
            getCompanyTitles();
            setAddCompanyTitle('');
            toast.success(`Company title added successfully!`);
          } else {
            toast.error(`Company already exists!`);
            setAddCompanyTitle('');
          }
        })
        .catch((err) => {
          console.error(err);
          // toast.error(`Failed to add company title`);
        });
    });
  };

  const updateJobTitle = (id) => {
    const body = {
      jobTitle: editedTitle?.trim(),
    };
    const token = localStorage.getItem('token');
    Api(`common/jobtitle/update/${id}`, 'PUT', body, token)
      .then((response) => {
        if (response.status === 200 && response.data.code === 200) {
          getJobTitles();
          toast.success('Job title updated successfully!');
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const updateSkillTitle = (id) => {
    const body = {
      skillName: editedTitle?.trim()?.toLowerCase(),
      // skillStatus: 'approved',
    };
    const token = localStorage.getItem('token');
    Api(`common/skill/update/${id}`, 'PUT', body, token)
      .then((response) => {
        if (response.status === 200 && response.data.code === 200) {
          getSkillTitles();
          toast.success('Skill title updated successfully!');
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const updateCompanyTitle = (id) => {
    const body = {
      companyName: editedTitle?.trim(),
      // companyNameStatus: 'approved',
    };
    const token = localStorage.getItem('token');
    Api(`common/companyName/update/${id}`, 'PUT', body, token)
      .then((response) => {
        if (response.status === 200 && response.data.code === 200) {
          getCompanyTitles();
          toast.success('Company title updated successfully!');
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const deleteJobTitle = (id) => {
    const body = {
      jobTitle: '',
    };
    const token = localStorage.getItem('token');
    Api(`common/jobtitle/delete/${id}`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200 && response.data.code === 200) {
          getJobTitles();
          toast.success('Job title deleted successfully!');
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const softdeleteJobTitle = (item) => {
    const body = {
      jobtitle_id: item._id,
      status: 'inactive',
    };
    const token = localStorage.getItem('token');
    Api(`common/softDeleteJobtitle`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200 && response.data.code === 200) {
          // getJobTitles();
          setSelectedType('deletedjobtitles');
          toast.success('Job title deleted successfully!');
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const softdeleteJobTitleMoveTo = (id) => {
    const body = {
      jobtitle_id: id,
      status: 'active',
    };
    const token = localStorage.getItem('token');
    Api(`common/softDeleteJobtitle`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200 && response.data.code === 200) {
          // getJobTitles();
          toast.success('Job Title moved successfully!');
          getJobTitles();
          setSelectedType('job');
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const softdeleteSkillTitle = (item) => {
    const body = {
      skill_id: item._id,
      status: 'inactive',
    };
    const token = localStorage.getItem('token');
    Api(`resume/softDeleteSkill`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200 && response.data.code === 200) {
          // getSkillTitles();
          toast.success('Skill title deleted successfully!');
          setSelectedType('deletedskills');
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const softdeleteSkillMove = (id) => {
    const body = {
      skill_id: id,
      status: 'active',
    };
    const token = localStorage.getItem('token');
    Api(`resume/softDeleteSkill`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200 && response.data.code === 200) {
          // getSkillTitles();
          toast.success('Skill moved successfully!');
          getSkillTitles();
          setSelectedType('skill');
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const deleteSkillTitle = (id) => {
    const body = {
      skillName: '',
    };
    const token = localStorage.getItem('token');
    Api(`common/skill/delete/${id}`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200 && response.data.code === 200) {
          getSkillTitles();
          toast.success('Skill title deleted successfully!');
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const softdeleteCompanyTitle = (item) => {
    const body = {
      company_id: item._id,
      status: 'inactive',
    };
    const token = localStorage.getItem('token');
    Api(`common/softDeleteCompany`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200 && response.data.code === 200) {
          // getCompanyTitles();
          toast.success('Company title deleted successfully!');
          setSelectedType('deletedcompanies');
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const softdeleteCompMove = (id) => {
    const body = {
      company_id: id,
      status: 'active',
    };
    const token = localStorage.getItem('token');
    Api(`common/softDeleteCompany`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200 && response.data.code === 200) {
          // getSkillTitles();
          toast.success('Company moved successfully!');
          getCompanyTitles();
          setSelectedType('company');
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const deleteCompanyTitle = (id) => {
    const body = {
      companyName: '',
    };
    const token = localStorage.getItem('token');
    Api(`common/companyName/delete/${id}`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200 && response.data.code === 200) {
          getCompanyTitles();
          toast.success('Company title deleted successfully!');
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const addTitleFunc = () => {
    if (selectedType === 'job') {
      addJobTitleFunc();
    } else if (selectedType === 'skill') {
      addSkillTitleFunc();
    } else if (selectedType === 'company') {
      addCompanyTitleFunc();
    } else if (selectedType === 'deletedskills') {
      toast.warn("Can't add deleted skills direclty");
    } else if (selectedType === 'deletedjobtitles') {
      toast.warn("Can't add deleted job titles direclty");
    } else if (selectedType === 'deletedcompanies') {
      toast.warn("Can't add deleted companies direclty");
    }
  };

  const addTitle = () => {
    if (selectedType === 'job') {
      return addJobTitle;
    }
    if (selectedType === 'skill') {
      return addSkillTitle;
    }
    if (selectedType === 'company') {
      return addCompanyTitle;
    }
    if (selectedType === 'deletedcompanies') {
      return addCompanyTitle;
    }
    if (selectedType === 'deletedskills') {
      return addSkillTitle;
    }
    if (selectedType === 'deletedjobtitles') {
      return addJobTitle;
    }

    return null;
  };

  const setAddTitle = (value) => {
    if (selectedType === 'job') {
      setAddJobTitle(value);
    } else if (selectedType === 'skill') {
      setAddSkillTitle(value);
    } else if (selectedType === 'company') {
      setAddCompanyTitle(value);
    } else if (selectedType === 'deletedcompanies') {
      setAddCompanyTitle(value);
    } else if (selectedType === 'deletedskills') {
      setAddSkillTitle(value);
    } else if (selectedType === 'deletedjobtitles') {
      setAddJobTitle(value);
    }
  };

  const deleteTitleFunc = () => {
    if (selectedType === 'job') {
      deleteJobTitle(deleteId);
    } else if (selectedType === 'skill') {
      deleteSkillTitle(deleteId);
    } else if (selectedType === 'company') {
      deleteCompanyTitle(deleteId);
    }
  };

  const deleteTitleFunc1 = () => {
    if (softDelete === 'softdeletetitle') {
      softdeleteJobTitle();
      // alert("title")
    } else if (softDelete === 'softdeleteskill') {
      softdeleteSkillTitle();
      // alert("skill")
    } else if (softDelete === 'softdeletecompany') {
      softdeleteCompanyTitle();
      // alert("company")
    }
  };

  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [altJobId, setAltJobId] = useState();
  const [altArr, setAltArr] = useState();
  const handleOpenModal = (altArr, id) => {
    setAltArr(altArr);
    // console.log("altArr", altArr)
    setModalOpen(true);
    setAltJobId(id);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    // setModalData(null);
  };

  const initialCities = [
    'New York',
    'Los Angeles',
    'Chicago',
    'Houston',
    'Phoenix',
    'Philadelphia',
    'San Antonio',
    'San Diego',
    'Dallas',
    'San Jose',
    'Austin',
    'Jacksonville',
    'Fort Worth',
    'Columbus',
    'Indianapolis',
    'Charlotte',
    'Seattle',
    'Denver',
    'Washington, D.C.',
    'Boston',
    // "El Paso", "Nashville", "Detroit", "Oklahoma City", "Portland",
    // "Las Vegas", "Memphis", "Louisville", "Baltimore", "Milwaukee",
    // "Albuquerque"
  ];

  const [cities, setCities] = useState(initialCities);
  const [editIndex, setEditIndex] = useState(null);
  const [editedCity, setEditedCity] = useState('');

  const handleEdit = (index) => {
    setEditIndex(index);
    setEditedCity(altArr[index]);
  };

  const handleSave = (index) => {
    // setLoadingSav(true)
    const updatedCities = [...altArr];
    updatedCities[index] = editedCity;
    setAltArr(updatedCities);
    // setEditIndex(null);
    editAlternativeJobTit(updatedCities);
  };

  const handleCityChange = (event) => {
    setEditedCity(event.target.value);
  };

  const tablebg = 'rgba(82, 130, 190, 0.08)';

  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [inputValue, setInputValue] = useState('');

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  //   const handleAddButtonClick = () => {
  //     if (inputValue.trim()) {

  //       console.log("Input value: ", inputValue);
  //       setInputValue('');
  //     }
  //   };

  const [loadingAdd, setLoadingAdd] = useState(false);
  const [loadingSav, setLoadingSav] = useState(false);
  const addAlternativeJobTit = () => {
    // setAltArr([...altArr, inputValue]);
    setLoadingAdd(true);
    const body = {
      jobTitle_id: altJobId,
      alternateJobTitle: inputValue?.trim(),
    };
    const token = localStorage.getItem('token');
    Api(`common/addAlternateJobTitle`, 'POST', body, token)
      .then((response) => {
        console.log('response.data.code', response);
        if (response.data.code === 404) {
          toast.warn('Alternate job title already Exist!');
          setLoadingAdd(false);
          handleClose();
          setInputValue('');
        } else {
          // getSkillTitles();
          // alert(response.message)
          // toast.success(response.message);
          setAltArr([...altArr, inputValue]);
          setLoadingAdd(false);
          toast.success('Alternative job title added successfully!');
          // getCompanyTitles()
          // setSelectedType("company")

          handleClose();
          setInputValue('');
          // handleCloseModal()
          getJobTitles();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const editAlternativeJobTit = (updatedCities) => {
    setLoadingSav(true);
    const body = {
      jobTitle_id: altJobId,
      NewJobTitleArray: updatedCities?.trim(),
    };
    const token = localStorage.getItem('token');
    Api(`common/editAlternateJobTitle`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200) {
          setLoadingSav(false);
          setEditIndex(null);
          // getSkillTitles();
          // alert(response.message)
          // toast.success(response.message);
          toast.success('Alternative job title updated successfully!');
          // getCompanyTitles()
          // setSelectedType("company")
          // handleClose()
          // setInputValue('')
          // handleCloseModal()
          getJobTitles();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  // console.log("altArr", altArr)
  const [checkedItems, setCheckedItems] = useState({});

  const handleCheckboxClick = (item) => {
    setCheckedItems((prevState) => {
      const newCheckedItems = { ...prevState };
      if (newCheckedItems[item._id]) {
        delete newCheckedItems[item._id];
      } else {
        newCheckedItems[item._id] = item;
      }
      return newCheckedItems;
    });
  };

  const moveToMultiple = (btn) => {
    // console.log("btn", btn)
    data.forEach((item) => {
      if (checkedItems[item._id]) {
        if (btn === 'job') {
          moveToJobTitle(item);
        } else if (btn === 'skill') {
          moveToSkill(item);
        } else if (btn === 'company') {
          moveToCompany(item);
        }
      }
    });
    setCheckedItems({});
  };

  const deleteMultiple = () => {
    // console.log("btn", btn)
    data.forEach((item) => {
      if (checkedItems[item._id]) {
        // if(btn === "job"){
        //     moveToJobTitle(item)
        // } else if (btn === "skill"){
        //     moveToSkill(item)
        // } else if (btn === "company"){
        //     moveToCompany(item)
        // }

        if (softDelete === 'job') {
          softdeleteJobTitle(item);
          // alert("title")
        } else if (softDelete === 'skill') {
          softdeleteSkillTitle(item);
          // alert("skill")
        } else if (softDelete === 'company') {
          softdeleteCompanyTitle(item);
          // alert("company")
        }
      }
    });
    setCheckedItems({});
  };

  const clearData = () => {
    setAddTitle('');

    if (selectedType === 'job') {
      getJobTitles();
    } else if (selectedType === 'skill') {
      getSkillTitles();
    } else if (selectedType === 'company') {
      getCompanyTitles();
    } else if (selectedType === 'deletedskills') {
      getSoftDeletedSkillsLst();
    } else if (selectedType === 'deletedjobtitles') {
      getJobTitlesLst();
    } else if (selectedType === 'deletedcompanies') {
      getSoftDeletedCompsLst();
    }
  };

  const commonSearch = () => {
    setLoading('Loading...');
    setData([]);

    if (selectedType === 'job') {
      setAddJobTitle(addJobTitle);
    } else if (selectedType === 'skill') {
      setAddSkillTitle(addSkillTitle);
    } else if (selectedType === 'company') {
      setAddCompanyTitle(addCompanyTitle);
    } else if (selectedType === 'deletedcompanies') {
      setAddCompanyTitle(addCompanyTitle);
    } else if (selectedType === 'deletedskills') {
      setAddSkillTitle(addSkillTitle);
    } else if (selectedType === 'deletedjobtitles') {
      setAddJobTitle(addJobTitle);
    }

    const status = ['job', 'skill', 'company'].includes(selectedType) ? 'active' : 'inactive';

    const body = {
      company: addCompanyTitle || '',
      skill: addSkillTitle ? [addSkillTitle] : [],
      jobTitle: addJobTitle || '',
    };
    const token = localStorage.getItem('token');
    Api(`company/searchInMasterData/${status}`, 'POST', body, token)
      .then((response) => {
        console.log('repo=======>>>>>>>>', response.data.status);
        if (response.status === 200) {
          if (response.data.status === 200) {
            setLoading('');
            // setData(response.data?.searchData)
            if (selectedType === 'job') {
              setData(response.data?.searchData);
            } else if (selectedType === 'skill') {
              setData(response.data?.searchData);
            } else if (selectedType === 'company') {
              setData(response.data?.searchData);
            } else if (selectedType === 'deletedcompanies') {
              setData(response.data?.searchData);
            } else if (selectedType === 'deletedskills') {
              setData(response.data?.searchData);
            } else if (selectedType === 'deletedjobtitles') {
              setData(response.data?.searchData);
            }
          }
          // getJobTitles()
        } else {
          setLoading('No data found');
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const renderTable = (data) => (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 600, backgroundColor: 'white' }}>
        <TableBody>
          {data &&
            data?.map((item) => (
              <>
                <TableRow key={item._id} sx={{ backgroundColor: '#EFF4FB', marginBottom: 2 }}>
                  {(selectedType === 'job' || selectedType === 'skill' || selectedType === 'company') && (
                    <FormControlLabel
                      sx={{ ml: 0.5, mt: -2 }}
                      control={
                        checkedItems[item._id] ? (
                          <Iconify
                            icon="ri:checkbox-circle-line"
                            color="#1976d2"
                            // width="900"
                            // height="900"
                            width="1.6rem"
                            onClick={() => handleCheckboxClick(item)}
                            // disabled={(item.jobTitleStatus !== "new" || item.skillStatus !== 'new' || item.companyNameStatus !== 'new')}
                            // sx={{
                            //   cursor: (item.jobTitleStatus !== "new" || item.skillStatus !== 'new' || item.companyNameStatus !== 'new')
                            //     ? 'not-allowed'
                            //     : 'pointer',
                            // }}
                          />
                        ) : (
                          <Iconify
                            icon="ri:checkbox-blank-circle-line"
                            width="1.6rem"
                            // height="900"
                            color="#1976d2"
                            onClick={() => handleCheckboxClick(item)}
                            // disabled={(item.jobTitleStatus !== "new" || item.skillStatus !== 'new' || item.companyNameStatus !== 'new')}
                            // sx={{
                            //   cursor: (item.jobTitleStatus !== "new" || item.skillStatus !== 'new' || item.companyNameStatus !== 'new')
                            //     ? 'not-allowed'
                            //     : 'pointer',
                            // }}
                          />
                        )
                      }
                    />
                  )}
                  <TableCell
                    sx={{
                      color:
                        (item.jobTitleStatus === 'new' ||
                          item.skillStatus === 'new' ||
                          item.companyNameStatus === 'new') &&
                        (selectedType === 'job' || selectedType === 'skill' || selectedType === 'company')
                          ? 'red'
                          : '#327CC0',

                      fontWeight: 'bold',
                      textTransform: 'capitalize',
                      cursor: selectedType === 'job' ? 'pointer' : '',
                    }}
                    onClick={() => {
                      if (selectedType === 'job' && !isEditing) {
                        handleOpenModal(item.alternateJobTitle, item._id);
                      }
                    }}
                  >
                    {isEditing && titleId === item._id ? (
                      <TextField
                        size="small"
                        value={editedTitle}
                        onChange={(event) => setEditedTitle(event.target.value)}
                      />
                    ) : (selectedType === 'job'
                        ? item?.jobTitle
                        : selectedType === 'skill'
                        ? item?.skillName
                        : selectedType === 'company'
                        ? item?.companyName?.charAt(0)?.toUpperCase() + item?.companyName?.slice(1)?.toLowerCase()
                        : selectedType === 'deletedskills'
                        ? item?.skillName
                        : selectedType === 'deletedjobtitles'
                        ? item?.jobTitle
                        : item?.companyName?.charAt(0)?.toUpperCase() + item?.companyName?.slice(1)?.toLowerCase()
                      )?.length > 75 ? (
                      `${(selectedType === 'job'
                        ? item?.jobTitle
                        : selectedType === 'skill'
                        ? item?.skillName
                        : selectedType === 'company'
                        ? item?.companyName
                        : selectedType === 'deletedskills'
                        ? item?.skillName
                        : selectedType === 'deletedjobtitles'
                        ? item?.jobTitle
                        : item?.companyName?.charAt(0)?.toUpperCase() + item?.companyName?.slice(1)?.toLowerCase()
                      )?.slice(0, 75)}...`
                    ) : selectedType === 'job' ? (
                      item?.jobTitle
                    ) : selectedType === 'skill' ? (
                      item?.skillName
                    ) : selectedType === 'company' ? (
                      item?.companyName?.charAt(0)?.toUpperCase() + item?.companyName?.slice(1)?.toLowerCase()
                    ) : selectedType === 'deletedskills' ? (
                      item?.skillName
                    ) : selectedType === 'deletedjobtitles' ? (
                      item?.jobTitle
                    ) : (
                      item?.companyName?.charAt(0)?.toUpperCase() + item?.companyName?.slice(1)?.toLowerCase()
                    )}
                  </TableCell>

                  {data && (
                    <TableCell sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                      {isEditing && titleId === item._id ? (
                        <Button
                          variant="contained"
                          sx={{
                            color: 'white',
                            backgroundColor: 'text.secondary',
                            boxShadow: 'none',
                            '&:hover': {
                              backgroundColor: 'text.secondary',
                            },
                          }}
                          onClick={handleSaveClick}
                        >
                          Save
                        </Button>
                      ) : selectedType === 'job' ? (
                        <>
                          {/* {item.jobTitleStatus === "new" && (

                                                        <Button
                                                            variant="contained"
                                                            sx={{
                                                                color: 'white',
                                                                backgroundColor: 'text.secondary',
                                                                boxShadow: 'none'

                                                            }}
                                                            onClick={() => moveToJobTitle(item._id, item.jobTitle
                                                            )}
                                                            disabled={isEditing}
                                                        >
                                                            Move To Job Title
                                                        </Button>
                                                    )} */}
                          {/* <Button
                                                        variant="contained"
                                                        sx={{
                                                            color: 'white',
                                                            backgroundColor: 'text.secondary',
                                                            boxShadow: 'none',
                                                            '&:hover': {
                                                                backgroundColor: 'text.secondary',
                                                            },
                                                        }}
                                                        onClick={() => handleEditClick(item._id, item.jobTitle)}
                                                        disabled={isEditing}
                                                    >
                                                        Edit
                                                    </Button> */}
                          {/* <IconButton onClick={() => handleEditClick(item._id, item.jobTitle)}> */}
                          <Iconify
                            onClick={() => handleEditClick(item._id, item.jobTitle)}
                            icon="mingcute:edit-line"
                            width="1.6rem"
                            color="#3C6BA5"
                          />
                          {/* </IconButton> */}
                          {/* <Button
                                                variant="contained"
                                                sx={{
                                                    color: 'white',
                                                    backgroundColor: 'error.main',
                                                    boxShadow: 'none',
                                                    '&:hover': {
                                                        backgroundColor: 'error.main',
                                                    },
                                                }}
                                                onClick={() => openDeleteModal(item._id)}
                                            >
                                                Delete
                                            </Button> */}

                          {/* <Button
                                                        variant="contained"
                                                        sx={{
                                                            color: 'white',
                                                            backgroundColor: 'error.main',
                                                            boxShadow: 'none',
                                                            '&:hover': {
                                                                backgroundColor: 'error.main',
                                                            },
                                                        }}
                                                        onClick={() => openDeleteModal(item._id, "softdeletetitle")}
                                                    >
                                                        Delete
                                                    </Button> */}
                          {/* <IconButton onClick={() => openDeleteModal(item._id, "softdeletetitle")}> */}
                          {/* <Iconify onClick={() => openDeleteModal(item._id, "softdeletetitle")}
                                                        icon="weui:delete-on-filled" width="1.6rem" color="red" /> */}
                          {/* </IconButton> */}
                        </>
                      ) : selectedType === 'skill' ? (
                        <>
                          {/* {item.skillStatus === 'new' && (
                                                        <Button
                                                            variant="contained"
                                                            sx={{
                                                                color: 'white',
                                                                backgroundColor: 'text.secondary',
                                                                boxShadow: 'none'
                                                            }}
                                                            onClick={() => moveToSkill(item._id, item.skillName)}
                                                            disabled={isEditing}
                                                        >
                                                            Move To Skill
                                                        </Button>
                                                    )} */}
                          {/* <Button
                                                        variant="contained"
                                                        sx={{
                                                            color: 'white',
                                                            backgroundColor: 'text.secondary', boxShadow: 'none'
                                                        }}
                                                        onClick={() => handleEditClick(item._id, item.skillName)}
                                                        disabled={isEditing}
                                                    >
                                                        Edit
                                                    </Button> */}
                          {/* <IconButton onClick={() => handleEditClick(item._id, item.skillName)}> */}
                          <Iconify
                            onClick={() => handleEditClick(item._id, item.skillName)}
                            icon="mingcute:edit-line"
                            width="1.6rem"
                            color="#3C6BA5"
                          />
                          {/* </IconButton> */}

                          {/* <Button
                                                    variant="contained"
                                                    sx={{
                                                        color: 'white',
                                                        backgroundColor: 'error.main',
                                                        boxShadow: 'none'
                                                    }}
                                                    onClick={() => openDeleteModal(item._id)}
                                                >
                                                    Delete
                                                </Button> */}
                          {/* {selectedType === 'skill' && (
                                                        // <Button
                                                        // variant="contained"
                                                        // sx={{
                                                        //     color: 'white',
                                                        //     backgroundColor: 'error.main',
                                                        //     boxShadow: 'none',
                                                        //     '&:hover': {
                                                        //         backgroundColor: 'error.main',
                                                        //     },
                                                        // }}
                                                        //     onClick={() => openDeleteModal(item._id, "softdeleteskill")}
                                                        // >
                                                        //     Delete
                                                        // </Button>
                                                        // <IconButton onClick={() => openDeleteModal(item._id, "softdeleteskill")}>
                                                        // </IconButton>
                                                        <Iconify onClick={() => openDeleteModal(item._id, "softdeleteskill")}
                                                            icon="weui:delete-on-filled" width="1.6rem" color="red" />
                                                    )} */}
                        </>
                      ) : (
                        <>
                          {selectedType === 'company' && (
                            <>
                              {/* <Button
                                                                variant="contained"
                                                                sx={{ color: 'white', backgroundColor: 'text.secondary', boxShadow: 'none' }}
                                                                onClick={() => handleEditClick(item._id, item.companyName)}
                                                                disabled={isEditing}
                                                            >
                                                                Edit
                                                            </Button> */}
                              {/* {item.companyNameStatus === 'new' && (
                                                                <Button
                                                                    variant="contained"
                                                                    sx={{ color: 'white', backgroundColor: 'text.secondary', boxShadow: 'none' }}
                                                                    onClick={() => moveToCompany(item._id, item.companyName)}
                                                                    disabled={isEditing}
                                                                >
                                                                    Move To Company
                                                                </Button>
                                                            )} */}
                              {/* <IconButton onClick={() => handleEditClick(item._id, item.companyName)}> */}
                              <Iconify
                                onClick={() => handleEditClick(item._id, item.companyName)}
                                icon="mingcute:edit-line"
                                width="1.6rem"
                                color="#3C6BA5"
                              />
                              {/* </IconButton> */}
                            </>
                          )}

                          {/* <Button
                                                variant="contained"
                                                sx={{ color: 'white', backgroundColor: 'error.main', boxShadow: 'none' }}
                                                onClick={() => openDeleteModal(item._id)}
                                            >
                                                Delete
                                            </Button> */}
                          {/* {selectedType === 'company' && (
                                                        // <Button
                                                        // variant="contained"
                                                        // sx={{
                                                        //     color: 'white',
                                                        //     backgroundColor: 'error.main',
                                                        //     boxShadow: 'none',
                                                        //     '&:hover': {
                                                        //         backgroundColor: 'error.main',
                                                        //     },
                                                        // }}
                                                        //     onClick={() => openDeleteModal(item._id, "softdeletecompany")}
                                                        // >
                                                        //     Delete
                                                        // </Button>
                                                        // <IconButton onClick={() => openDeleteModal(item._id, "softdeletecompany")}>
                                                        <Iconify onClick={() => openDeleteModal(item._id, "softdeletecompany")}
                                                            icon="weui:delete-on-filled" width="1.6rem" color="red" />
                                                        // </IconButton>
                                                    )} */}
                          {selectedType === 'deletedskills' && item.skillStatus === 'new' && (
                            <>
                              <Button
                                variant="contained"
                                sx={{ color: 'white', backgroundColor: 'text.secondary', boxShadow: 'none' }}
                                onClick={() => softdeleteSkillMove(item._id)}
                                // disabled={isEditing}
                              >
                                Move to Skill
                              </Button>

                              {/* <Button 
                                                    variant="contained"
                                                    sx={{ color: 'white', backgroundColor: 'text.secondary', boxShadow: 'none' }}
                                                    // onClick={() => moveToCompany(item._id, item.companyName)}
                                                    // disabled={isEditing}
                                                >
                                                    Record
                                                </Button> */}
                              <IconButton
                                sx={{
                                  // position:"absolute",
                                  width: 30,
                                  height: 30,
                                  // ml: 9,
                                  // mt: -3.8,
                                  backgroundColor: 'lightgrey',
                                  borderRadius: '50%',
                                  padding: 0,
                                  '&:hover': {
                                    backgroundColor: 'grey',
                                  },
                                }}
                              >
                                {item?.record?.length || '0'}
                              </IconButton>
                            </>
                          )}

                          {selectedType === 'deletedjobtitles' && (
                            <>
                              {item.jobTitleStatus === 'new' && (
                                <Button
                                  variant="contained"
                                  sx={{ color: 'white', backgroundColor: 'text.secondary', boxShadow: 'none' }}
                                  onClick={() => softdeleteJobTitleMoveTo(item._id)}
                                  // disabled={isEditing}
                                >
                                  Move to Job Title
                                </Button>
                              )}
                              <IconButton
                                sx={{
                                  // position:"absolute",
                                  width: 30,
                                  height: 30,
                                  // ml: 9,
                                  // mt: -3.8,
                                  backgroundColor: 'lightgrey',
                                  borderRadius: '50%',
                                  padding: 0,
                                  '&:hover': {
                                    backgroundColor: 'grey',
                                  },
                                }}
                              >
                                {item?.record?.length || '0'}
                              </IconButton>
                            </>
                          )}
                          {selectedType === 'deletedcompanies' && item.companyNameStatus === 'new' && (
                            <>
                              <Button
                                variant="contained"
                                sx={{ color: 'white', backgroundColor: 'text.secondary', boxShadow: 'none' }}
                                onClick={() => softdeleteCompMove(item._id)}
                                // disabled={isEditing}
                              >
                                Move to Company
                              </Button>
                              <IconButton
                                sx={{
                                  // position:"absolute",
                                  width: 30,
                                  height: 30,
                                  // ml: 9,
                                  // mt: -3.8,
                                  backgroundColor: 'lightgrey',
                                  borderRadius: '50%',
                                  padding: 0,
                                  '&:hover': {
                                    backgroundColor: 'grey',
                                  },
                                }}
                              >
                                {item?.record?.length || '0'}
                              </IconButton>
                            </>
                          )}
                        </>
                      )}
                    </TableCell>
                  )}
                </TableRow>
                <TableCell />
              </>
            ))}
        </TableBody> 
      </Table>
    </TableContainer>
  );

  return (

    <Stack>
      <Helmet>
        <title> Master Data | Foxearch </title>
      </Helmet>
      <ToastContainer />
      <Typography variant="h5" color="text.secondary" sx={{ marginBottom: '6px' }}>
        Master Data
      </Typography>
      <Stack sx={{ flexDirection: 'row', gap: '10px', marginBottom: '10px' }}>
        <Typography
          sx={{
            backgroundColor: selectedType === 'job' ? 'secondary.main' : 'text.secondary',
            color: 'white',
            padding: 1,
            borderRadius: '5px',
            cursor: 'pointer',
          }}
          onClick={() => {
            setSelectedType('job');
            setAddJobTitle('');
            setAddSkillTitle('');
            setAddCompanyTitle('');
            setAddTitle('');
          }}
        >
          Job Titles
        </Typography>
        <Typography
          sx={{
            backgroundColor: selectedType === 'skill' ? 'secondary.main' : 'text.secondary',
            color: 'white',
            padding: 1,
            borderRadius: '5px',
            cursor: 'pointer',
          }}
          onClick={() => {
            setSelectedType('skill');
            setAddJobTitle('');
            setAddSkillTitle('');
            setAddCompanyTitle('');
            setAddTitle('');
          }}
        >
          Skills
        </Typography>
        <Typography
          sx={{
            backgroundColor: selectedType === 'company' ? 'secondary.main' : 'text.secondary',
            color: 'white',
            padding: 1,
            borderRadius: '5px',
            cursor: 'pointer',
          }}
          onClick={() => {
            setSelectedType('company');
            setAddJobTitle('');
            setAddSkillTitle('');
            setAddCompanyTitle('');
            setAddTitle('');
          }}
        >
          Companies
        </Typography>
        <Typography
          sx={{
            backgroundColor: selectedType === 'deletedjobtitles' ? 'secondary.main' : 'text.secondary',
            color: 'white',
            padding: 1,
            borderRadius: '5px',
            cursor: 'pointer',
          }}
          onClick={() => {
            setSelectedType('deletedjobtitles');
            setAddJobTitle('');
            setAddSkillTitle('');
            setAddCompanyTitle('');
            setAddTitle('');
          }}
        >
          Deleted Job Titles
        </Typography>
        <Typography
          sx={{
            backgroundColor: selectedType === 'deletedskills' ? 'secondary.main' : 'text.secondary',
            color: 'white',
            padding: 1,
            borderRadius: '5px',
            cursor: 'pointer',
          }}
          onClick={() => {
            setSelectedType('deletedskills');
            setAddJobTitle('');
            setAddSkillTitle('');
            setAddCompanyTitle('');
            setAddTitle('');
          }}
        >
          Deleted Skills
        </Typography>
        <Typography
          sx={{
            backgroundColor: selectedType === 'deletedcompanies' ? 'secondary.main' : 'text.secondary',
            color: 'white',
            padding: 1,
            borderRadius: '5px',
            cursor: 'pointer',
          }}
          onClick={() => {
            setSelectedType('deletedcompanies');
            setAddJobTitle('');
            setAddSkillTitle('');
            setAddCompanyTitle('');
            setAddTitle('');
          }}
        >
          Deleted Companies
        </Typography>
      </Stack>
      <Grid container spacing={1} alignItems="center" sx={{ mt: '-14px', mb: '7px' }}>
        <Grid item xs={12} sm={6} md={2}>
          <TextField
            label={
              selectedType === 'job'
                ? 'Job Title'
                : selectedType === 'skill'
                ? 'Skill'
                : selectedType === 'company'
                ? 'Company Name'
                : selectedType === 'deletedcompanies'
                ? 'Deleted Company Name'
                : selectedType === 'deletedskills'
                ? 'Deleted Skill'
                : 'Deleted Job Title'
            }
            variant="outlined"
            fullWidth
            margin="normal"
            size="small"
            value={addTitle()}
            onChange={(e) => setAddTitle(e.target.value)}
            InputProps={{ style: { borderRadius: '7px', paddingLeft: '10px' } }}
            InputLabelProps={{ style: { marginLeft: '1px' } }}
          />
        </Grid>

        <Grid item xs={6} sm={6} md={1}>
          <Button
            fullWidth
            color="custom"
            variant="contained"
            disabled={!addTitle()}
            onClick={addTitleFunc}
            sx={{
              bgcolor: 'text.secondary',
              color: 'white',
              borderRadius: '7px',
              height: '35px',
              mt: 1,
            }}
          >
            Add New
          </Button>
        </Grid>

        <Grid item xs={6} sm={6} md={1}>
          <Button
            fullWidth
            color="custom"
            variant="contained"
            disabled={!addTitle()}
            onClick={commonSearch}
            sx={{
              bgcolor: 'text.secondary',
              color: 'white',
              borderRadius: '7px',
              height: '35px',
              mt: 1,
            }}
          >
            Search
          </Button>
        </Grid>

        <Grid item xs={6} sm={6} md={1}>
          <Button
            fullWidth
            color="custom"
            variant="contained"
            disabled={!addTitle()}
            onClick={clearData}
            sx={{
              bgcolor: 'text.secondary',
              color: 'white',
              borderRadius: '7px',
              height: '35px',
              mt: 1,
            }}
          >
            Clear
          </Button>
        </Grid>

        {(selectedType === 'job' || selectedType === 'company' || selectedType === 'skill') && (
          <Grid item xs={12} md={7} container spacing={1} justifyContent="flex-end">
            <Grid item xs={12} sm={6} md="auto">
              <Button
                fullWidth
                color="custom"
                variant="contained"
                sx={{
                  bgcolor: 'text.secondary',
                  color: 'white',
                  borderRadius: '7px',
                  height: '35px',
                  mt: 1,
                }}
                onClick={() => moveToMultiple(selectedType)}
              >
                {selectedType === 'job'
                  ? 'Move to Job Title'
                  : selectedType === 'skill'
                  ? 'Move to Skill'
                  : 'Move to Company'}
              </Button>
            </Grid>

            <Grid item xs={12} sm={6} md="auto">
              <Button
                fullWidth
                color="custom"
                variant="contained"
                sx={{
                  bgcolor: 'text.secondary',
                  color: 'white',
                  borderRadius: '7px',
                  height: '35px',
                  mt: 1,
                }}
                onClick={() => openDeleteModal(selectedType)}
              >
                {selectedType === 'job'
                  ? 'Delete Job Title'
                  : selectedType === 'skill'
                  ? 'Delete Skill'
                  : 'Delete Company'}
              </Button>
            </Grid>
          </Grid>
        )}
      </Grid>

      {loading ? (
        <Typography sx={{ color: 'red', ml: '45%', mt: 4 }}>{loading}</Typography>
      ) : (
        <Stack direction="row" spacing={2}>
          {renderTable(splitData.part1)}
          {renderTable(splitData.part2)}
        </Stack>
      )}
      <Modal open={del} onClose={closeDeleteModal} style={{ borderRadius: 10 }}>
        <Box sx={[style, { width: '20%' }]}>
          <Stack sx={{ justifyContent: 'center', alignContent: 'center', width: '100%' }}>
            <Stack sx={{ width: '100%' }}>
              <Typography variant="h6" textAlign={'center'} color={'red'}>
                Do you want to delete selected{' '}
                {selectedType === 'job' ? 'job title' : selectedType === 'skill' ? 'skill' : 'company'} ?
              </Typography>
            </Stack>
            <Stack
              sx={{ flexDirection: 'row', justifyContent: 'space-between', width: '25%', mt: 3, alignSelf: 'center' }}
            >
              <Button
                color="custom"
                variant="contained"
                size="small"
                onClick={() => {
                  deleteMultiple();
                  closeDeleteModal();
                  // if (softDelete) { deleteTitleFunc1(); closeDeleteModal()}
                  // else {
                  //     closeDeleteModal();deleteTitleFunc();
                  // }
                }}
              >
                Yes
              </Button>
              <Button color="custom" variant="contained" size="small" onClick={closeDeleteModal}>
                No
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>

      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '35%',
            bgcolor: 'background.paper',
            border: '2px solid #3C6BA5',
            boxShadow: 24,
            p: 3,
            borderRadius: 2,
          }}
        >
          <Stack sx={{ justifyContent: 'center', alignContent: 'center', width: '100%' }}>
            <Typography
              sx={{
                color: '#3C6BA5',
                fontWeight: 'bold',
                textAlign: 'center',
                fontSize: '20px',
                flexGrow: 1,
                mt: -2,
              }}
            >
              Alternative Job Title
            </Typography>
            <Divider sx={{ mt: 1, mb: 1 }} />
            <Stack sx={{ width: '100%' }}>
              <TextField
                fullWidth
                label="Add Alternative Job Title"
                variant="outlined"
                value={inputValue}
                onChange={handleInputChange}
                //   size="small"
              />
            </Stack>
            {/* <Stack sx={{ mt: 2 }}> */}
            {/* </Stack> */}
          </Stack>
          <Grid item xs={6} textAlign="center" sx={{ mt: 2, height: '24px' }}>
            <Button
              color="custom"
              variant="contained"
              size="small"
              disabled={inputValue === '' || loadingAdd}
              sx={{
                // color: 'white',
                paddingTop: 0.8,
                paddingBottom: 0.8,
                // mt: 2,
                // alignItems: 'center',
                // backgroundColor: 'text.secondary',
                // boxShadow: 'none',
                // flexShrink: 0,
                // display: 'block',
                // marginLeft: 'auto',
                // marginRight: 'auto',
                // '&:hover': {
                //   backgroundColor: 'text.secondary',
                //   boxShadow: 'none',
                // },
              }}
              onClick={() => addAlternativeJobTit()}
            >
              {/* Add */}
              {loadingAdd ? <CircularProgress size={22} /> : 'Add'}
            </Button>
          </Grid>
        </Box>
      </Modal>

      <Popover
        open={modalOpen}
        onClose={handleCloseModal}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'center',
        }}
        PaperProps={{
          style: {
            border: '1px solid #3C6BA5',
            boxShadow: '24',
          },
        }}
      >
        <Box
          sx={{
            width: '80vh',
            height: '80vh',
            bgcolor: 'background.paper',
            p: 2,
            borderRadius: 1,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
            <Typography
              sx={{
                color: '#3C6BA5',
                fontWeight: 'bold',
                textAlign: 'center',
                fontSize: '20px',
                flexGrow: 1,
              }}
            >
              Alternative Job Title List
            </Typography>
            <Button
              variant="contained"
              sx={{
                color: 'white',
                backgroundColor: 'text.secondary',
                boxShadow: 'none',
                '&:hover': {
                  backgroundColor: 'text.secondary',
                  boxShadow: 'none',
                },
              }}
              onClick={() => handleOpen()}
            >
              Add
            </Button>
          </Box>

          <Divider sx={{ mt: 2, mb: 2 }} />
          <Box
            sx={{
              overflowY: 'auto',
              height: '80vh',
              flexGrow: 1,
              '&:hover': {
                overflowY: 'auto',
              },
              scrollbarWidth: 'thin',
              '&::-webkit-scrollbar': {
                width: '8px',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#888',
                borderRadius: '4px',
              },
              '&::-webkit-scrollbar-thumb:hover': {
                backgroundColor: '#555',
              },
              paddingRight: '16px',
            }}
          >
            {altArr?.length === 0 ? (
              <Typography sx={{ color: 'red', textAlign: 'center' }}>No data found</Typography>
            ) : (
              // altArr?.filter((_, index) => index !== "" && index !== undefined)?.map((city, index) => (
              altArr?.map((city, index) => (
                <Box
                  sx={[
                    {
                      display: 'flex',
                      alignItems: 'center',
                      marginBottom: 1,
                      background: index % 2 === 0 ? 'text.background' : tablebg,
                      '&:last-child td, &:last-child th': { border: 0 },
                      // '&:hover': { boxShadow: 5 },
                    },
                  ]}
                  key={index}
                >
                  {editIndex === index ? (
                    <TextField
                      variant="outlined"
                      // margin="normal"
                      size="small"
                      value={editedCity}
                      onChange={handleCityChange}
                      sx={{ width: '70%', m: 0.7 }}
                    />
                  ) : (
                    <Typography sx={{ flexGrow: 1, m: 0.9 }}>{city}</Typography>
                  )}

                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', width: '30%' }}>
                    {editIndex === index ? (
                      <Button
                        variant="contained"
                        disabled={!editedCity || loadingSav}
                        sx={{
                          color: 'white',
                          backgroundColor: 'text.secondary',
                          boxShadow: 'none',
                          flexShrink: 0,
                          '&:hover': {
                            backgroundColor: 'text.secondary',
                            boxShadow: 'none',
                          },
                        }}
                        onClick={() => handleSave(index)}
                      >
                        {loadingSav ? <CircularProgress size={21} sx={{ color: 'white' }} /> : 'Save'}
                      </Button>
                    ) : (
                      city !== '' &&
                      city !== 0 && (
                        <Button
                          sx={{
                            color: 'white',
                            backgroundColor: 'text.secondary',
                            boxShadow: 'none',
                            flexShrink: 0,
                            '&:hover': {
                              backgroundColor: 'text.secondary',
                              boxShadow: 'none',
                            },
                          }}
                          onClick={() => handleEdit(index)}
                        >
                          Edit
                        </Button>
                      )
                    )}
                  </Box>
                </Box>
              ))
            )}
          </Box>
        </Box>
      </Popover>
    </Stack>
  );
};

export default MasterData;
